var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitationImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1460.269,
    height: 660.351,
    viewBox: "0 0 1460.269 660.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.799,
    y1: 0.097,
    x2: 0.184,
    y2: 0.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9f5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6e5ae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.799,
    y1: 0.097,
    x2: 0.184,
    y2: 0.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1d8ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474b4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0,
    y2: 1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.132,
    y1: 0.188,
    x2: -0.094,
    y2: 0.876,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25495",
    "data-name": "Group 25495",
    transform: "translate(-406.163 -257.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    transform: "translate(1006.586 731.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_lines",
    "data-name": "Mobile lines",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M323.455-267.229h.637V-312.5a18.289,18.289,0,0,1,18.27-18.269h46.58a18.928,18.928,0,0,0,18.906-18.906V-434.3a18.289,18.289,0,0,1,18.268-18.268H544.889v-.637H426.116A18.927,18.927,0,0,0,407.21-434.3v84.626a18.29,18.29,0,0,1-18.269,18.269h-46.58A18.927,18.927,0,0,0,323.455-312.5v45.273",
    transform: "translate(-323.455 453.208)",
    fill: "#7f8998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path784",
    d: "M538.235-440.079a10.617,10.617,0,0,1,10.6,10.605,10.617,10.617,0,0,1-10.6,10.606,10.617,10.617,0,0,1-10.606-10.606A10.617,10.617,0,0,1,538.235-440.079Zm0,21.848a11.255,11.255,0,0,0,11.242-11.243,11.255,11.255,0,0,0-11.242-11.242,11.255,11.255,0,0,0-11.243,11.242,11.255,11.255,0,0,0,11.243,11.243",
    transform: "translate(-437.978 447.463)",
    fill: "#7f8998"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Settings_icon",
    "data-name": "Settings icon",
    d: "M234.578-441.315a18.6,18.6,0,0,0,2.445-26.2,18.6,18.6,0,0,0-26.2-2.445,18.6,18.6,0,0,0-2.446,26.2A18.606,18.606,0,0,0,234.578-441.315Zm-44.234.866a35.518,35.518,0,0,1-2.922-9.475l-6.69-2.009.705-7.554.705-7.555,6.945-.736a35.544,35.544,0,0,1,4.626-8.771l-3.308-6.145,5.841-4.844,5.84-4.844,5.427,4.388a35.5,35.5,0,0,1,9.475-2.922l2.009-6.69,7.555.7,7.555.705.735,6.946a35.5,35.5,0,0,1,8.771,4.625l6.145-3.307,4.845,5.84,4.843,5.84-4.387,5.427a35.528,35.528,0,0,1,2.922,9.476l6.689,2.009-.7,7.554-.706,7.555-6.945.736a35.535,35.535,0,0,1-4.626,8.77L255-428.578l-5.841,4.844-5.84,4.843-5.427-4.387a35.558,35.558,0,0,1-9.475,2.922l-2.009,6.69-7.554-.705-7.555-.705-.735-6.946a35.491,35.491,0,0,1-8.771-4.626l-6.145,3.308-4.844-5.84-4.844-5.841,4.387-5.427",
    transform: "translate(-9.953 497.605)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "translate(215.74 83.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M127.872-45.929h-5.631v.073h5.631v-.073",
    transform: "translate(-40.113 132.943)",
    fill: "#d9d7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M293.76-46.639H282.347v-.073H293.76v.073",
    transform: "translate(-240.925 133.555)",
    fill: "#d9d7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M262.728-51.379h-5.1v-.073h5.1v.073",
    transform: "translate(-204.5 137.261)",
    fill: "#d9d7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M442.974-216.346a5.979,5.979,0,0,0,5.979,5.979,5.979,5.979,0,0,0,5.979-5.979,5.979,5.979,0,0,0-5.979-5.979,5.979,5.979,0,0,0-5.979,5.979",
    transform: "translate(-437.135 270.861)",
    fill: "#ebe9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46-2",
    "data-name": "path46",
    d: "M172.088-313.136c-.722-2.113-.149-3.617,1.614-3.617a7.09,7.09,0,0,1,3.812,1.556,1.179,1.179,0,0,1,1.259-.879c1.2,0,2.861,1.017,4.161,2.453a1.99,1.99,0,0,1,1.355-.548,6.017,6.017,0,0,1,3.757,1.471.651.651,0,0,1,.533-.274,2.569,2.569,0,0,1,2.007,1.317c.028.048.053.094.077.141H171.737a2.382,2.382,0,0,1,.35-1.621",
    transform: "translate(-113.7 344.691)",
    fill: "#ebe9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M140.343-369.332l-66.3,9.544-8.9,8.98,75.2-18.524",
    transform: "translate(-40.129 385.802)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M307.463-323.536l10.418-2.566-1.52-6.414,13.445-1.935-13.445,1.935-8.9,8.98",
    transform: "translate(-282.451 358.529)",
    fill: "#d5e3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M131.445-369.332l-66.3,9.544L68.218-346.8l63.226-22.529",
    transform: "translate(-31.231 385.802)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M68.218-346.8h0l8.539-9.532,12.811-3.045-10.981-2.343-13.445,1.935,1.52,6.414,1.557,6.571m36.415-16.157,26.812-6.372-26.258,3.78-.553,2.592",
    transform: "translate(-31.231 385.802)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M178.736-443.4l-3.85,18.04a1.822,1.822,0,0,0,1.4,2.155l34.342,7.329a1.821,1.821,0,0,0,2.155-1.4l3.85-18.04a1.818,1.818,0,0,0-.29-1.421,1.816,1.816,0,0,0-1.108-.735L180.891-444.8a1.817,1.817,0,0,0-1.311.218,1.819,1.819,0,0,0-.844,1.179",
    transform: "translate(-140.387 444.835)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M211-415.834a1.823,1.823,0,0,0,1.778-1.437l.273-1.279-5.608,2,3.179.679a1.8,1.8,0,0,0,.377.04m-12.279-2.58,15.065-3.58,2.842-13.317a1.806,1.806,0,0,0,.04-.375,1.826,1.826,0,0,0-.33-1.045,1.816,1.816,0,0,0-1.108-.735L180.892-444.8a1.8,1.8,0,0,0-.378-.04,1.827,1.827,0,0,0-.934.258,1.819,1.819,0,0,0-.844,1.179l-3.85,18.04a1.81,1.81,0,0,0-.04.376,1.823,1.823,0,0,0,1.437,1.779l.657.141,3.776.806.073.015,3.427.731.073.015,14.434,3.08",
    transform: "translate(-140.387 444.835)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M176.357-444.577l11.475,14.086a7.4,7.4,0,0,0,9.059,1.934l16.226-8.174a1.817,1.817,0,0,0-1.108-.735L177.668-444.8a1.817,1.817,0,0,0-1.311.218",
    transform: "translate(-137.163 444.835)",
    fill: "#aad08e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M128.368-369.332l-54.688,13L65.142-346.8l63.226-22.529",
    transform: "translate(-28.154 385.802)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M65.142-346.8l3.343-1.191.073-.026,3.427-1.221.073-.026,14.431-5.142,5.429-1.934.07-.025,1.984-.707,1.243-.443,5.608-2,27.547-9.815-54.688,13L65.142-346.8",
    transform: "translate(-28.154 385.802)",
    fill: "#d5e3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M156.067-308.08l6.085-3.565L162-311.9l-6.085,3.565.147.251",
    transform: "translate(-81.739 340.894)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M196.287-286.8l2.189-1.282-.147-.251-2.189,1.282.147.251",
    transform: "translate(-126.836 322.472)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M119.829-369.332l-54.688,13,10.63,12.813Z",
    transform: "translate(-19.615 385.802)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M357.549-246.549a.579.579,0,0,0,.214-.041l8.91-3.527a.581.581,0,0,0,.327-.755.581.581,0,0,0-.755-.327l-8.91,3.528a.581.581,0,0,0-.327.755.582.582,0,0,0,.541.368",
    transform: "translate(-330.482 293.47)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M357.549-246.549a.579.579,0,0,0,.214-.041l8.91-3.527a.582.582,0,0,0,.368-.542.579.579,0,0,0-.041-.213.581.581,0,0,0-.54-.368.585.585,0,0,0-.215.041l-8.91,3.528a.582.582,0,0,0-.368.542.58.58,0,0,0,.041.213.582.582,0,0,0,.541.368",
    transform: "translate(-330.483 293.47)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M374.052-264.117a.585.585,0,0,0,.214-.041l4.785-1.895a.581.581,0,0,0,.327-.755.581.581,0,0,0-.755-.327l-4.785,1.895a.581.581,0,0,0-.327.755.581.581,0,0,0,.541.368",
    transform: "translate(-346.46 305.928)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M374.052-264.117a.586.586,0,0,0,.214-.041l4.785-1.895a.581.581,0,0,0,.368-.542.581.581,0,0,0-.041-.213.581.581,0,0,0-.54-.368.584.584,0,0,0-.215.041l-4.785,1.895a.581.581,0,0,0-.368.542.581.581,0,0,0,.041.213.581.581,0,0,0,.541.368",
    transform: "translate(-346.46 305.928)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M310.305-246.636a.584.584,0,0,0,.214-.041l8.687-3.439a.582.582,0,0,0,.327-.755.582.582,0,0,0-.755-.327l-8.687,3.439a.581.581,0,0,0-.327.755.582.582,0,0,0,.541.368",
    transform: "translate(-272.711 293.468)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M310.306-246.636a.585.585,0,0,0,.214-.041l2.522-1,.073-.029,3.427-1.357.073-.029,2.593-1.026a.582.582,0,0,0,.368-.542.58.58,0,0,0-.041-.213.581.581,0,0,0-.541-.368.587.587,0,0,0-.214.041l-8.687,3.439a.582.582,0,0,0-.368.542.581.581,0,0,0,.041.213.582.582,0,0,0,.541.368",
    transform: "translate(-272.711 293.469)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M487.6-350.32c-.77,1.5-1.477,3.01-2.148,4.553s-1.3,3.1-1.844,4.738l-.2.62c-.033.11-.085.291-.112.42s-.056.273-.072.4a10.489,10.489,0,0,0-.1,1.415,24.95,24.95,0,0,0,.121,2.6,41.813,41.813,0,0,0,.792,5.009l1.595-.177c.021-1.638.036-3.293.093-4.906.029-.805.075-1.609.156-2.367a9.513,9.513,0,0,1,.173-1.054c.016-.082.038-.144.057-.212s.033-.089.065-.175l.219-.55c.608-1.472,1.292-2.956,1.989-4.434l2.112-4.431-2.9-1.449",
    transform: "translate(-481.456 370.937)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M503.921-262.854l.745,1.393-2.378.663a2.487,2.487,0,0,1,.087-2l1.547-.052",
    transform: "translate(-499.768 302.55)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M501.219-254.462l-2.187.172-1.1-1.517,2.378-.663.912,2.008",
    transform: "translate(-495.41 297.558)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M448.63-397.647c.034.169.152.288.262.265s.172-.178.138-.347-.152-.288-.262-.265-.172.178-.138.346",
    transform: "translate(-432.474 408.213)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M444.828-395.062a6.169,6.169,0,0,0,1.1,1.28.992.992,0,0,1-.776.315l-.324-1.6",
    transform: "translate(-428.536 405.919)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M450.315-401.953a.1.1,0,0,0,.074-.033.8.8,0,0,1,.679-.273.1.1,0,0,0,.116-.083.1.1,0,0,0-.083-.116,1,1,0,0,0-.861.335.1.1,0,0,0,.005.143l.069.027",
    transform: "translate(-434.968 411.707)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M450.974-385.506c.306,1.563.612,4.427-.481,5.47,0,0,.427,1.586,3.332,1.586,3.194,0,1.526-1.585,1.526-1.585-1.743-.416-1.7-1.71-1.395-2.924l-2.982-2.546",
    transform: "translate(-439.628 398.447)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M450.933-364.065c-.231-.766-.485-1.643.041-1.917.578-.3,3.741-.61,4.831-.043s.781,2.121.781,2.121l-5.653-.16",
    transform: "translate(-440.508 383.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M505.864-25.616l.062.006a.137.137,0,0,1,.094.068c.046.084.019.119.01.13-.092.12-.528.122-.847.068A1.66,1.66,0,0,1,505.864-25.616Zm-.267.407a.687.687,0,0,0,.513-.141.206.206,0,0,0,0-.24.235.235,0,0,0-.159-.118c-.314-.072-.9.331-.927.348l-.021.051.038.04a2.693,2.693,0,0,0,.558.061",
    transform: "translate(-501.88 117.139)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M507.614-27.992h.023c.066.008.072.038.074.051.026.141-.246.495-.466.661a1.219,1.219,0,0,1,.252-.669A.178.178,0,0,1,507.614-27.992Zm-.432.866.024-.006c.221-.12.649-.588.6-.826a.166.166,0,0,0-.161-.133.281.281,0,0,0-.216.065c-.248.2-.3.819-.3.846l.023.046.027.008",
    transform: "translate(-504.011 118.997)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M446.713-25.646a.381.381,0,0,1,.1.012.152.152,0,0,1,.1.071c.036.063.023.094.01.112-.1.133-.636.141-1.037.085A2.286,2.286,0,0,1,446.713-25.646Zm-.339.415c.274,0,.538-.038.627-.161a.192.192,0,0,0,0-.221.254.254,0,0,0-.161-.118c-.353-.095-1.1.329-1.134.347l-.025.052.04.042a3.739,3.739,0,0,0,.656.06",
    transform: "translate(-429.827 117.162)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M448.786-27.991h.03c.091.009.1.045.1.057.023.145-.324.508-.587.666a1.187,1.187,0,0,1,.282-.659A.269.269,0,0,1,448.786-27.991Zm-.521.866.021,0c.258-.115.769-.577.73-.819-.009-.057-.049-.127-.188-.142a.371.371,0,0,0-.281.087,1.443,1.443,0,0,0-.332.823l.021.046.03.009",
    transform: "translate(-432.364 118.997)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M451.664-41.626H453.8l.213-4.948h-2.137l-.213,4.948",
    transform: "translate(-438.112 133.447)",
    fill: "#f3646c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M506.527-41.626h2.137l1.074-4.948H507.6l-1.074,4.948",
    transform: "translate(-505.803 133.447)",
    fill: "#f3646c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M498.5-25.025h-2.4a.186.186,0,0,0-.182.146l-.422,1.9a.314.314,0,0,0,.313.38c.838-.015,1.245-.063,2.3-.063.649,0,1.988.067,2.884.067.877,0,1.014-.887.647-.967a5.291,5.291,0,0,1-2.793-1.33.517.517,0,0,0-.347-.132",
    transform: "translate(-495.487 116.599)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M431.993-25.025H429.66a.187.187,0,0,0-.182.146l-.422,1.9a.311.311,0,0,0,.308.38c.841-.014,2.058-.063,3.116-.063,1.237,0,2.305.067,3.756.067.877,0,1.12-.887.753-.967-1.671-.366-3.036-.4-4.481-1.3a.988.988,0,0,0-.514-.167",
    transform: "translate(-416.319 116.599)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M361.477-380.758a49.585,49.585,0,0,0,5.324-.708c.882-.169,1.765-.358,2.648-.6a20.788,20.788,0,0,0,2.665-.879c.224-.092.45-.2.675-.3a6.429,6.429,0,0,0,.726-.423c.42-.278.78-.564,1.137-.849.712-.57,1.374-1.162,2.027-1.76,1.3-1.2,2.535-2.448,3.723-3.758l-1.07-1.2-4.22,3.033c-.7.5-1.4.993-2.091,1.455-.345.229-.7.446-1.017.627a3.458,3.458,0,0,1-.419.205c-.173.067-.348.134-.532.2a31.183,31.183,0,0,1-4.806,1.076c-1.661.263-3.377.479-5.034.651l.265,3.228",
    transform: "translate(-344.771 402.923)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M483.5-358.448c-2,.459-4.027,6.314-4.027,6.314l4.122,2.957s1.152-2.727,2.284-5.112c1.187-2.5-.332-4.628-2.379-4.159",
    transform: "translate(-476.464 377.343)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M492.377-349.075s.319-.756.786-1.819h0c-.356.809-.626,1.44-.735,1.7h0a22.318,22.318,0,0,1,.535-4.539,44.367,44.367,0,0,0-.681-4.607h0l.193-.037c-.064.01-.128.022-.193.037-2,.459-4.027,6.314-4.027,6.314l.739.53,2.644,1.9.739.53",
    transform: "translate(-485.243 377.241)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M484.261-343.548l.817,1.829c-.846,1.827-1.62,3.635-1.827,4.119a16.988,16.988,0,0,1,1.009-5.948",
    transform: "translate(-476.068 365.642)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M488.255-332.552c.11-.257.38-.888.735-1.7-.042-.925-.107-1.877-.2-2.843a22.315,22.315,0,0,0-.535,4.539",
    transform: "translate(-481.07 360.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M444.581-360.09s2.274,2.569.126,18.467H433.279c-.079-1.754,1.024-10.312-.668-18.578a29.85,29.85,0,0,1,3.826-.483,41.929,41.929,0,0,1,4.858,0,21.444,21.444,0,0,1,3.286.593",
    transform: "translate(-425.572 379.096)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M433.279-341.623h11.428a87.8,87.8,0,0,0,.923-11.541c0-.611-.012-1.171-.033-1.683a13.056,13.056,0,0,1-2.146-.875,6.151,6.151,0,0,1-2.913-.968,3.013,3.013,0,0,1-1.1-2.15c0-.9.622-1.677,2.075-1.822l-.218-.022c-.566-.052-1.293-.072-2.054-.072-.966,0-1.987.032-2.8.071a29.842,29.842,0,0,0-3.826.483,44.372,44.372,0,0,1,.681,4.608c.094.966.158,1.918.2,2.843h0c.049,1.059.068,2.083.068,3.054,0,3.738-.285,6.7-.285,7.862,0,.078,0,.148,0,.21m12.307-13.471c-.007-.146-.015-.288-.023-.426h0q.013.207.024.426",
    transform: "translate(-425.573 379.096)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M435.769-343.548c.076.6.134,1.315.172,2.155a11.937,11.937,0,0,1-3.182-1.495l3.01-.66",
    transform: "translate(-415.916 365.642)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M434.906-336.805q-.016-.351-.036-.673c-.665-.037-1.4-.1-2.111-.2a13.052,13.052,0,0,0,2.146.875h0",
    transform: "translate(-414.881 361.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M422.388-357.988c1.529,1.355,7.37,1.219,7.37,1.219l.193-5.646a43.326,43.326,0,0,1-5.954.432c-3.264-.066-3.286,2.508-1.609,4",
    transform: "translate(-407.423 380.393)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M429.318-356.765c.277,0,.44,0,.44,0l.193-5.646a45.065,45.065,0,0,1-5.534.436q-.212,0-.42,0l-.122,0c-1.819,0-2.586.848-2.587,1.847a3.013,3.013,0,0,0,1.1,2.15,6.152,6.152,0,0,0,2.913.968c.709.1,1.446.165,2.111.2h0c.792.044,1.482.053,1.905.053",
    transform: "translate(-407.423 380.393)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M352.458-397.235l1.466-1.712,1.566,1.734a2.74,2.74,0,0,1-2.5,1.366l-.533-1.388",
    transform: "translate(-317.948 408.957)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M349.626-408.1l.564,2.234-1.069,1.5-1.566-1.734,2.071-2",
    transform: "translate(-311.579 416.114)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M453.914-46.568l-.109,2.551h-2.137l.109-2.551h2.138",
    transform: "translate(-438.013 133.443)",
    fill: "#e04c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M507.081-46.568h2.138l-.555,2.551h-2.137l.554-2.551",
    transform: "translate(-505.285 133.443)",
    fill: "#e04c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M455.849-420.274c1.917-.886,2.523-4.752-2.991-3.794,0,0,.831.921-.857,1.5s-.275,4.2,3.848,2.292",
    transform: "translate(-441.235 428.716)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M447.527-405.96c.549,2.048.766,3.275,2.03,4.126a2.817,2.817,0,0,0,4.343-2.36c.066-1.954-.843-4.975-3.04-5.388a2.892,2.892,0,0,0-3.332,3.622",
    transform: "translate(-437.076 417.313)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M463.137-419.9c-1.3.73-3.074,1.165-2.9,2.2.218,1.265-1.069.473-.77,2.358.2,1.23,2.465,4.958,4.062,4.776,2.4-.274,2.1-3.941,2.1-5.869,0-1.136.058-4.9-2.5-3.464",
    transform: "translate(-451.439 425.592)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M457.193-411.266c.582.137,1.352,3.49-.9,3.8-2.593.353.9-3.8.9-3.8",
    transform: "translate(-442.705 418.588)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M448.584-413.286c.713.063,2.321-.8,2.129-2.085a7.537,7.537,0,0,1-2.129,2.085",
    transform: "translate(-434.155 421.798)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M454.618-396.58a2.4,2.4,0,0,0,1.054,1.122c.614.32.96-.148.821-.763-.125-.553-.6-1.387-1.228-1.455s-.9.515-.647,1.1",
    transform: "translate(-441.246 407.968)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M479.779-411.119a2.859,2.859,0,0,1-1.682-2.13s-.96,2.681,1.682,2.13",
    transform: "translate(-469.607 420.139)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M482.676-405.817a1.472,1.472,0,0,1,1.392-.137s-.9-1.162-1.392.137",
    transform: "translate(-474.931 414.809)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M469.725-273.046s-2.425,16.328-3.756,22.446c-1.458,6.7-8.411,31.66-8.411,31.66h-2.133s3.3-24.421,4.134-31.053c.9-7.2,2.791-23.053,2.791-23.053h7.374",
    transform: "translate(-454.644 310.519)",
    fill: "#445263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M455.426-219.848h3.543c1.235-5.033,6.136-25.079,7.371-30.752q.027-.122.053-.25c-.108-1.717-.211-3.95-.211-6.213a29.491,29.491,0,0,1,.861-8.281c-.218-4.336-.406-7.7-.406-7.7h-3.916s-1.889,15.854-2.791,23.053c-.71,5.658-3.714,25.366-4.5,30.145",
    transform: "translate(-455.014 310.519)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M461.938-246.453c-2.8.55-2.507,11.005-2.17,16.383.808-3.8,1.992-11.116,2.8-16.308a.962.962,0,0,0-.631-.076",
    transform: "translate(-448.39 289.743)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M467.727-223.238c.313-1.472.683-3.472,1.065-5.671-.125-2.925-.276-6.072-.415-8.828a29.5,29.5,0,0,0-.861,8.281c0,2.263.1,4.5.211,6.213a.02.02,0,0,1,0,0",
    transform: "translate(-456.349 282.911)",
    fill: "#4e782f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M443.66-273.046s.294,15.975.062,22.491c-.242,6.777-3.493,31.606-3.493,31.606h-2.144s-.724-24.432-.885-31.089c-.175-7.256-1.051-23.008-1.051-23.008h7.512",
    transform: "translate(-424.525 310.519)",
    fill: "#445263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M437.482-219.927h3.434c.254-2.425,1.139-10.7,1.648-16.062.542-5.707,1.053-11.607,1.158-14.567.066-1.842.089-4.44.089-7.22,0-7.052-.151-15.271-.151-15.271h-7.512s.187,3.366.406,7.7c.139,2.755.291,5.9.415,8.828h0c.1,2.409.186,4.667.229,6.432,0,.016,0,.031,0,.046.112,4.626.21,16.565.26,23.417,0,.024,0,.048,0,.073.008,1.177.015,2.2.021,3.008,0,.024,0,.048,0,.073,0,.211,0,1.99,0,2.169m5.335-36.46c0,2.777-.024,5.374-.089,7.205-.19,5.331-1.695,20.192-2.333,26.334l-.036.032h0l-.032-.04h0c.638-6.141,2.142-21,2.332-26.329.065-1.83.089-4.426.089-7.2,0-5.478-.09-11.66-.129-14.056h0l.036-.037h0l.036.036c.039,2.4.13,8.58.13,14.058",
    transform: "translate(-424.525 310.519)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "M440.744-219.912l.036-.033c.638-6.142,2.142-21,2.333-26.334.194-5.442.018-17.651-.041-21.264l-.036-.036h0l-.036.037c.059,3.612.235,15.82.041,21.26-.19,5.329-1.694,20.188-2.332,26.329l.032.04h0",
    transform: "translate(-424.91 306.243)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M440.744-219.912l.036-.033c.638-6.142,2.142-21,2.333-26.334.065-1.831.089-4.428.089-7.205,0-5.479-.09-11.661-.13-14.058l-.036-.036h0l-.036.037c.039,2.4.129,8.579.129,14.056,0,2.777-.024,5.373-.089,7.2-.19,5.329-1.694,20.188-2.332,26.329l.032.04h0",
    transform: "translate(-424.91 306.243)",
    fill: "#4e782f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Parson",
    transform: "translate(57.687 15.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54-2",
    "data-name": "path54",
    d: "M310.838-377.473c-.1-7.041-9.478-20.138-9.478-20.138a3.727,3.727,0,0,0-.44-.166c-.006.006-.483-.067-.483-.061s-1.457-1.38-1.466-1.38c-.344,1.252-3.45,18.94-4.211,29.237C303.565-371.71,310.889-374.115,310.838-377.473Zm-78.574-31.8q-.836-11.287-1.166-21.126c1.816-.962,4-2.086,5.745-2.915,5.406-2.574,12.938-6.04,17.771-8.257,2.829-1.3,5.6-2.25,5.6-2.25s19.315-1.851,20.883-1.752a48.527,48.527,0,0,1,6.076,2.078c6.849,2.6,20.055,7.891,22.157,9.4,3.084,2.207,14.117,56.291,14.41,59.964.286,3.568-15.006,8.45-29.167,12.189.01,5.483.121,13.164.246,20.176.019,1.2.041,2.374.064,3.514H232.919c.083-1.2.156-2.393.216-3.514.006-.15.016-.3.022-.443.236-4.749,1.159-13.256.924-21.54,0,0,.15-8.733-.717-12.491-.1-16.6-1.1-33.034-1.1-33.034",
    transform: "translate(-177.63 503.419)",
    fill: "#92be70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56-2",
    "data-name": "path56",
    d: "M354.99-339.264c.408-2.934.793-5.866,1.141-8.736,0-.016.006-.025.006-.042.112-.956.227-1.9.335-2.838.007-.045.009-.1.016-.15.453-3.953.828-7.745,1.1-11.217a35.5,35.5,0,0,0-.346-7.8c-1.077-17.756-1.613-36.475-1.613-36.475-.567-7.662-.892-14.824-1.108-21.5,0,0,24.254-11.463,26.453-12.119,0,0-4.6,10.8-8.051,34.949-1.325,9.274-3.782,24.885-5.565,40.818v0c-.965,8.6-2.775,17.356-4.151,25.108-.21,1.2-.411,2.371-.6,3.514H354.49q.259-1.753.5-3.514",
    transform: "translate(-301.502 500.92)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58-2",
    "data-name": "path58",
    d: "M270.776-383.013c.213-8.079.176-13.717.176-13.717-.8,2.768-1.906,10.678-2.88,18.541C271.349-379.839,270.734-381.382,270.776-383.013ZM241.6-369.428c-.956-8.978-1.816-17.936-1.4-22.845,3.345-39.467,12.81-49.913,14.184-51.443,1.061.4,5.1,1.921,6.283,2.389,6.474,2.552,19.669,7.229,21.447,8.507,3.084,2.208,15.241,58.907,15.608,62.574.246,2.479-15.621,7.658-31.808,12.281.15,4.438-.27,10.7,1.2,17.235a15.129,15.129,0,0,1,.7,3.425l-22.565-.089q-.205-1.749-.424-3.514c-.429-3.527-.879-7.139-1.324-10.978-6.767,1.751-11.368,2.88-11.368,2.88s-6.356-10.746-8.2-15.1c-.315-.742,7.866-2.708,17.666-5.325",
    transform: "translate(-147.727 502.564)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60-2",
    "data-name": "path60",
    d: "M329.912-460.173s-2.456-4.642-1.777-17.822c.187-3.651-19.179,8.659-19.179,8.659s.067,1.258.109,2.956c.022.707.035,1.481.035,2.278,0,.22,0,.439,0,.66,0,.36-.006.717-.013,1.074-.009.443-.026.876-.048,1.293-.022.475-.054.923-.1,1.335a12.148,12.148,0,0,1-.717,2.588c-.889,2.048,14.442,2.166,21.693-3.02",
    transform: "translate(-225.43 518.639)",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62-2",
    "data-name": "path62",
    d: "M337.672-428.9l-3.569,4.8s2.091,2.8,5.805.732l-2.236-5.528",
    transform: "translate(-249.428 495.751)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66-2",
    "data-name": "path66",
    d: "M323.249-438.344l3.821,4.471s6.134-1.188,7.934-4.392-11.755-.079-11.755-.079",
    transform: "translate(-238.825 500.721)",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-2",
    "data-name": "path64",
    d: "M348.3-419.773s-13.077,31.938-10.287,72.507l4.124,7.485,4.651-6.375s.75-53.879,4.462-73.746l-2.95.128",
    transform: "translate(-262.667 491.612)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68-2",
    "data-name": "path68",
    d: "M340.7-444.426s.444,3.408,4.7,8.384l-4.644,6.239-2.513-12.943,2.459-1.68",
    transform: "translate(-257.155 502.89)",
    fill: "#759c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70-2",
    "data-name": "path70",
    d: "M321.768-452.015s-8.868,10.031-15.07,12.483l2.884,7.133,14.154-15.613-1.968-4",
    transform: "translate(-218.453 506.38)",
    fill: "#759c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72-2",
    "data-name": "path72",
    d: "M385.148-346.795s11.772-11.417,19.492-13.315c3.569-.879,8.27-5.806,12.737-11.6,1.472-1.907,2.917-3.909,4.291-5.89a.012.012,0,0,0,0-.008c5.481-7.914,9.775-15.5,9.775-15.5s16.2-18.985,3.2-27.448c0,0-5.571-.12-8.628,1.54-3.142,1.706-9.845,15.694-10.981,18.172s-13.447,25.482-14.271,26a34.156,34.156,0,0,1-7.124,5.061c-6.031,3.247-15.5,12.75-15.5,12.75l7.009,10.236",
    transform: "translate(-373.003 491.912)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74-2",
    "data-name": "path74",
    d: "M352.694-276.447a7.476,7.476,0,0,0,2.349-.447s1.23-.789,2.138-1.3a6.868,6.868,0,0,1,.718-.363,13.7,13.7,0,0,0,3.954-1.884c1.548-1.18,6.594-5.9,6.594-5.9l-3.262-5.014-1.506-4.965s-11.765,1.17-13.334,2.1a4.662,4.662,0,0,0-.432.289,17.446,17.446,0,0,0-2.4,2.685c-.22.206-2.269,2.4-2.154,3.289a2.932,2.932,0,0,0,1.534,2.4,7.008,7.008,0,0,0,1.658,3.479,4.354,4.354,0,0,0,2.238,3.127s.57,2.227,1.906,2.495",
    transform: "translate(-284.043 434.777)",
    fill: "#efaa88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76-2",
    "data-name": "path76",
    d: "M322.792-540.707s-21.265-5.126-16.786,21.8,9.58,29.109,22.534,23.741,12.054-22.589,12.825-31.016-11.771-14.129-18.574-14.523",
    transform: "translate(-235.407 547.347)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78-2",
    "data-name": "path78",
    d: "M309.472-507.579c.315-2.365,5.011-3.164,5.336.392s-2.271,9.755-4.039,9.115-1.733-6.247-1.3-9.508",
    transform: "translate(-210.915 532.865)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80-2",
    "data-name": "path80",
    d: "M338.157-517.742s-.426-8.468-3.511-8.778-3.612,3.091-3.612,3.091l-3.129.544s1.1-7.4-1.971-8.742-20.051,3.789-22.5,1.576-1.059-17.237,3.451-19.23,16.948-6.424,25.921-.156c0,0,7.077-.7,8.041,5.015s-.71,22.468-2.693,26.68",
    transform: "translate(-233.442 552.669)",
    fill: "#16202e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82-2",
    "data-name": "path82",
    d: "M292.241-302.443l8.78,15.1s23.26-5.994,28.688-7.525L317.3-309.638s-18.292,4.179-25.061,7.2",
    transform: "translate(-216.617 440.904)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84-2",
    "data-name": "path84",
    d: "M317.526-454.558h0a20.337,20.337,0,0,0,15.827-9.943,23.577,23.577,0,0,1-15.766,6.916c0,.22,0,.439,0,.66,0,.36-.006.716-.013,1.074-.009.443-.026.876-.047,1.293",
    transform: "translate(-233.921 512.122)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88-2",
    "data-name": "path88",
    d: "M429.682-329.948C416.462-316.34,399-299.2,399-299.2l-6.828-12.961s15.514-18.187,26.031-30.322c3.223,1.581,9.142,5.351,11.483,12.538",
    transform: "translate(-392.168 457.533)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90-2",
    "data-name": "path90",
    d: "M384.331-285.4a38.779,38.779,0,0,0-4.488,2.485c-.93.767-4.695,3.586-5.608,4.249s1.377,2.549,8.109-.367,1.987-6.368,1.987-6.368",
    transform: "translate(-317.047 429.755)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(49.353 178.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-2",
    "data-name": "path106",
    d: "M111.224-250.951v0",
    transform: "translate(110.673 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108-2",
    "data-name": "path108",
    d: "M111.224-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(107.259 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110-2",
    "data-name": "path110",
    d: "M117.544-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(97.526 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112-2",
    "data-name": "path112",
    d: "M123.864-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(87.79 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114-2",
    "data-name": "path114",
    d: "M130.185-250.951v3.514H133.6v-3.514h-3.414",
    transform: "translate(78.057 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116-2",
    "data-name": "path116",
    d: "M136.5-250.951v3.514h3.414v-3.514H136.5",
    transform: "translate(68.323 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118-2",
    "data-name": "path118",
    d: "M142.825-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(58.589 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120-2",
    "data-name": "path120",
    d: "M149.145-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(48.856 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122-2",
    "data-name": "path122",
    d: "M155.466-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(39.12 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124-2",
    "data-name": "path124",
    d: "M161.786-250.951v3.514H165.2v-3.514h-3.414",
    transform: "translate(29.386 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126-2",
    "data-name": "path126",
    d: "M168.108-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(19.651 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128-2",
    "data-name": "path128",
    d: "M174.428-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(9.917 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130-2",
    "data-name": "path130",
    d: "M180.749-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(0.182 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132-2",
    "data-name": "path132",
    d: "M187.069-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-9.552 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134-2",
    "data-name": "path134",
    d: "M193.389-250.951v3.514H196.8v-3.514h-3.414",
    transform: "translate(-19.286 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136-2",
    "data-name": "path136",
    d: "M199.709-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-29.018 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138-2",
    "data-name": "path138",
    d: "M206.029-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-38.753 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140-2",
    "data-name": "path140",
    d: "M212.35-250.951v3.514h3.414v-3.514H212.35",
    transform: "translate(-48.487 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142-2",
    "data-name": "path142",
    d: "M218.67-250.951v3.514h3.414v-3.514H218.67",
    transform: "translate(-58.221 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144-2",
    "data-name": "path144",
    d: "M224.99-250.951v3.514H228.4v-3.514H224.99",
    transform: "translate(-67.954 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146-2",
    "data-name": "path146",
    d: "M231.31-250.951v3.514h3.415v-3.514H231.31",
    transform: "translate(-77.69 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148-2",
    "data-name": "path148",
    d: "M237.633-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-87.425 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150-2",
    "data-name": "path150",
    d: "M243.953-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-97.159 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152-2",
    "data-name": "path152",
    d: "M250.273-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-106.893 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154-2",
    "data-name": "path154",
    d: "M256.593-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-116.628 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156-2",
    "data-name": "path156",
    d: "M262.914-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-126.362 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158-2",
    "data-name": "path158",
    d: "M269.234-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-136.096 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160-2",
    "data-name": "path160",
    d: "M275.554-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-145.829 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162-2",
    "data-name": "path162",
    d: "M281.874-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-155.563 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164-2",
    "data-name": "path164",
    d: "M288.194-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-165.297 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166-2",
    "data-name": "path166",
    d: "M294.515-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-175.032 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168-2",
    "data-name": "path168",
    d: "M300.835-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-184.766 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M307.157-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-194.501 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M313.477-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-204.235 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174-2",
    "data-name": "path174",
    d: "M319.8-250.951v3.514h3.414v-3.514H319.8",
    transform: "translate(-213.971 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176-2",
    "data-name": "path176",
    d: "M326.118-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-223.704 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178-2",
    "data-name": "path178",
    d: "M332.438-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-233.438 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180-2",
    "data-name": "path180",
    d: "M338.758-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-243.172 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182-2",
    "data-name": "path182",
    d: "M345.079-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-252.907 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184-2",
    "data-name": "path184",
    d: "M351.4-250.951v3.514h3.414v-3.514H351.4",
    transform: "translate(-262.639 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "M357.719-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-272.373 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M364.039-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-282.108 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "M370.36-250.951v3.514h3.414v-3.514H370.36",
    transform: "translate(-291.844 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M376.682-250.951v3.514H380.1v-3.514h-3.414",
    transform: "translate(-301.578 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M383-250.951v3.514h3.414v-3.514H383",
    transform: "translate(-311.311 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M389.322-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-321.045 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M395.642-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-330.78 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M401.963-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-340.514 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    d: "M408.283-250.951v3.514H411.7v-3.514h-3.414",
    transform: "translate(-350.248 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "M414.6-250.951v3.514h3.414v-3.514H414.6",
    transform: "translate(-359.981 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "M420.923-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-369.715 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M427.244-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-379.451 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M433.564-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-389.184 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "M439.886-250.951v3.514H443.3v-3.514h-3.414",
    transform: "translate(-398.92 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "M446.206-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-408.654 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "M452.527-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-418.389 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M458.847-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-428.123 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M465.167-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-437.856 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "M471.487-250.951v3.514H474.9v-3.514h-3.414",
    transform: "translate(-447.59 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M477.807-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-457.324 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M484.128-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-467.059 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "M490.448-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-476.791 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "M496.768-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-486.525 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "M503.088-250.951v3.514H506.5v-3.514h-3.415",
    transform: "translate(-496.26 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "M509.411-250.951v3.514h3.413v-3.514h-3.413",
    transform: "translate(-505.996 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M515.731-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-515.73 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    d: "M522.051-247.438v0",
    transform: "translate(-522.05 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102-2",
    "data-name": "path102",
    d: "M333.12-250.951v3.514h-221.9v-3.514Z",
    transform: "translate(-111.224 250.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Laptop",
    transform: "translate(38.282 117.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92-2",
    "data-name": "path92",
    d: "M447.79-357.508l6.2,57.673H372.345l-6.2-57.673H447.79",
    transform: "translate(-361.412 360.807)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96-2",
    "data-name": "path96",
    d: "M367.749-260.337H354.112v5.189h13.637v-5.189",
    transform: "translate(-268.671 316.12)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "M448.01-310.059c.656,3.21-.842,6.229-3.346,6.74s-5.066-1.677-5.722-4.888.841-6.229,3.345-6.741,5.066,1.677,5.722,4.888",
    transform: "translate(-394.821 341.268)",
    fill: "#d4ebc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94-2",
    "data-name": "path94",
    d: "M461.436-305.944H380.429l-6.135-57.036H455.3Zm-81.579.638h82.288l-6.271-58.31H373.586l6.272,58.31",
    transform: "translate(-373.586 363.616)",
    fill: "#a6a6a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Visitor",
    transform: "translate(1575.332 301.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25489",
    "data-name": "Group 25489",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Setting_Icon",
    "data-name": "Setting Icon",
    d: "M627.04-309.616a26.9,26.9,0,0,1,.354-38.038,26.9,26.9,0,0,1,38.039.355,26.9,26.9,0,0,1-.354,38.038A26.9,26.9,0,0,1,627.04-309.616Zm63.49,7.783a51.366,51.366,0,0,0,5.6-13.2l9.918-1.9.1-10.97.1-10.97-9.88-2.084a51.391,51.391,0,0,0-5.356-13.3l5.665-8.349L689-370.43l-7.684-7.829-8.454,5.509a51.368,51.368,0,0,0-13.195-5.6l-1.9-9.918-10.97-.1-10.97-.1-2.085,9.88a51.386,51.386,0,0,0-13.3,5.356l-8.35-5.665-7.829,7.685-7.828,7.685,5.508,8.454a51.3,51.3,0,0,0-5.6,13.195l-9.918,1.9-.1,10.97-.1,10.969,9.881,2.084a51.366,51.366,0,0,0,5.356,13.3l-5.665,8.349,7.684,7.829,7.685,7.83,8.454-5.509a51.4,51.4,0,0,0,13.2,5.6l1.9,9.918,10.97.1,10.97.1,2.084-9.882a51.294,51.294,0,0,0,13.3-5.355l8.349,5.665,7.83-7.685,7.829-7.685-5.509-8.454",
    transform: "translate(-477.89 394.202)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    d: "M708.256-106.811h-291.1v-5.321h291.1v5.321",
    transform: "translate(-417.156 320.517)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25491",
    "data-name": "Group 25491",
    transform: "translate(9.646 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "M571.728-312.147s-25.967,24.71-13.336,43.949,18.544,2.388,18.544,2.388,8.543,2.579-4.137-21.143c-5.977-11.181-1.071-25.194-1.071-25.194",
    transform: "translate(-500.97 356.956)",
    fill: "#bbd070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path758",
    d: "M607.62-315.086s12.491-36.63-11.345-47.986-44.074,5.06-47.9,13.942-2.811,25.034.449,36.3,2.786,28.408-4.3,34.142-15.866,15.257-15.432,34.643c.27,12.026,47.325-30.764,47.325-30.764l31.2-40.273",
    transform: "translate(-496.262 366.938)",
    fill: "#252e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path760",
    d: "M572.488-250.476s-19.592,4.342-27.369,8.887-25.044,25.448-25.044,34.437S595.6-189.768,595.6-189.768l14.314,52.258s38.171-9.315,42.715-17.04-14.5-63.092-17.756-74.3c-3.325-11.431-17.006-19.4-32.911-21.63a109.227,109.227,0,0,0-29.469,0",
    transform: "translate(-494.621 345.901)",
    fill: "#43a1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path762",
    d: "M610.824-250.785s-.439,23.812-19.324,24.518-14.953-22.839-14.953-22.839,13.812-5.6,34.277-1.679",
    transform: "translate(-504.847 346.031)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path764",
    d: "M624.129-338.337s6.68,38.3-12.344,65.963c-19.7,28.652,12.344-65.963,12.344-65.963",
    transform: "translate(-510.162 361.727)",
    fill: "#252e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path766",
    d: "M607.348-272.8s-1.314,11.389.879,18.474-28.874,7.279-28.858,1.455c.021-6.617,3.179-12.144.2-23.485s27.775,3.557,27.775,3.557",
    transform: "translate(-505.424 351.212)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path768",
    d: "M584.113-269.286s9.809,10.219,22.353,1.066c0,0-1.036,6.532-10.058,7.374s-12.294-8.441-12.294-8.441",
    transform: "translate(-506.288 349.148)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path770",
    d: "M592.994-354.684s24.79,7.336,21.248,41.74-19.731,32.631-21.248,32.885-20.744,1.518-26.814-40.221,26.814-34.4,26.814-34.4",
    transform: "translate(-502.884 364.796)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path772",
    d: "M586.193-339.815s13.471,21.428,27.649,26.4c0,0,7.742-35.955-24.232-43.489S562.644-320.589,565.03-308.9a95.043,95.043,0,0,1,21.163-30.919",
    transform: "translate(-502.484 365.268)",
    fill: "#252e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path774",
    d: "M569.216-343.386s7.091-13.732,19.064-14.346,19.094,9.773,19.094,9.773-4.675-11.695-19.079-11.695-19.079,16.267-19.079,16.267",
    transform: "translate(-503.574 365.611)",
    fill: "#88c0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path776",
    d: "M604.17-207.7l8.407,78.159H501.927L493.52-207.7H604.17",
    transform: "translate(-489.783 337.928)",
    fill: "#101c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path780",
    d: "M571.593-163.136c.993,4.862-1.275,9.433-5.066,10.209s-7.67-2.539-8.663-7.4,1.274-9.433,5.065-10.209,7.67,2.538,8.664,7.4",
    transform: "translate(-501.463 331.178)",
    fill: "#afc8ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path782",
    d: "M626.309-121.738h20.648v7.856H626.309v-7.856",
    transform: "translate(-513.975 322.267)",
    fill: "#101c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path778",
    d: "M498.327-134h109.68l-8.3-77.2H490.024Zm110.755.963H497.462l-8.511-79.124H600.572l8.511,79.124",
    transform: "translate(-488.951 338.741)",
    fill: "#405b7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25490",
    "data-name": "Group 25490",
    transform: "translate(178.471 125.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path460",
    d: "M2278.733-1332.042a70.833,70.833,0,0,0-1.773-9.886,1.5,1.5,0,0,1,1.445-1.895h13.258l2.165,11.781s-15.372.468-15.094,0",
    transform: "translate(-2266.959 1366.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "M2291.409-1332.042a70.791,70.791,0,0,0-1.774-9.886,1.5,1.5,0,0,1,1.446-1.895h13.257l2.166,11.781s-15.374.468-15.094,0",
    transform: "translate(-2278.373 1366.807)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    d: "M2387.032-1573.367a5.493,5.493,0,0,0-2.664-1,6.566,6.566,0,0,1-1.078-.07c-4.279-.575-6.854,5.643-7.006,7.527-.279,3.473-2.117,4-4.7,6.178-5.185,4.36-3.665,9.428-.829,11.311,1.7,1.131,4.7,0,4.7,0,.042.03,8.2-4.56,12.222-6.775,6.028-.857,1.843-15.189-.642-17.167",
    transform: "translate(-2349.113 1574.478)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "M2455-1417.1s-5.624-1.422-7.059-2.665c-1.216-1.054-3.788-10.858-5.015-13.346-.828-1.678-4.516-2.8-5.527-3-.03-.032.862,9.11-.491,8.033-4.153-3.3-3.482-5.6-4.878-8.528-.085-.177-2.031,2.658-3.824,6.057-1.977,3.752-1.435,4.547-.878,6.883q.153.637.258,1.178c.668,3.4.1,4.091.9,6.311.232.642,6.339,1.214,9.812.984a4.756,4.756,0,0,0,2.243-.486c1.065-.925,1.124.7,1.227-6.041.271.668,2.079,5.421,3.19,5.935,1.56.723,10.486.2,10.486.2L2455-1417.1",
    transform: "translate(-2401.925 1450.359)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    d: "M2481.007-1466.83c.018.012.445,5.642-.466,5.74-1.365.146-5.553-8.515-5.534-8.516.571-.027,1.2-.526,1.68-3.8l.243.086,4.091,1.472s-.3,1.313-.49,2.562a3.707,3.707,0,0,0,.475,2.459",
    transform: "translate(-2445.319 1483.481)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path470",
    d: "M2498.4-1471.071s-.3,1.313-.489,2.562c-2.349-.422-3.271-2.764-3.6-4.034l4.091,1.472",
    transform: "translate(-2462.702 1482.701)",
    fill: "#d59171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    d: "M2495.317-1533.633s-5.6-.751-5.074-4.228.15-5.918,3.744-5.584,4.089,1.763,4.2,2.965-1.4,6.953-2.867,6.847",
    transform: "translate(-2459.006 1546.565)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M2483.478-1545.164s-3.582,3.086-6.019,3.336-3.359-.534-3.359-.534a9.521,9.521,0,0,0,2.3-3.117,1.713,1.713,0,0,1,1.412-1.01c1.74-.15,5.038-.219,5.665,1.325",
    transform: "translate(-2444.502 1549.345)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    d: "M2545.727-1541.351a8.824,8.824,0,0,1,1.575,2.018,6.764,6.764,0,0,1,.183,3.6s1.868-3.631.811-5.394a1.492,1.492,0,0,0-2.569-.225",
    transform: "translate(-2508.993 1545.254)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path478",
    d: "M2445.283-1330.184c-3.473.23-9.58-.343-9.812-.985-.8-2.22-.235-2.911-.9-6.311l1.675-4.717s-.278,5.252,1.271,6.634,6.343,2.668,7.1,3.823a4.25,4.25,0,0,1,.672,1.556",
    transform: "translate(-2408.909 1365.343)",
    fill: "#588834"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    d: "M2502.167-1248.624s3.427-.764,3.979-.46a8.041,8.041,0,0,1,2.073,1.8c.17.385-1.23-.292-1.686-.415a4.023,4.023,0,0,0-1.455.319,4.853,4.853,0,0,1-2.61.262l-.3-1.5",
    transform: "translate(-2469.773 1281.573)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path482",
    d: "M2378.836-1436.57s-4.6.283-6.192,2.5c-2.243,3.127-6.691,16.455-4.142,18.231,2.87,2,13.065.523,13.065.523a4.132,4.132,0,0,0-.133-2.352c-.471-.768-8.142-2.006-8.5-2.361s4.424-6.9,4.424-7.965,1.473-8.582,1.473-8.582",
    transform: "translate(-2348.738 1450.311)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path484",
    d: "M2543.767-1238.864a6.632,6.632,0,0,0,.952,1.036.7.7,0,0,0,.388.084l-.483-.87-.857-.25",
    transform: "translate(-2507.226 1272.306)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M2542.1-1248.437l2.087,1.014a.37.37,0,0,1-.345.134,5,5,0,0,1-.906-.249l-.836-.9",
    transform: "translate(-2505.726 1280.926)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path488",
    d: "M2463.337-1438.746a4.858,4.858,0,0,0-1.957.467s1.488,5.271,3.981,7.334l.667-.473v1.075l2.495,1.634s-5.313-8.7-5.186-10.036",
    transform: "translate(-2433.051 1452.274)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path490",
    d: "M2531.02-1432.892s.829,6.055.2,8.893c0,0,1.021-1.877,1.165-2.221l-.171-1.031.659.228s-.523-4.835-1.108-5.636c-.26-.353-.722-.857-.722-.857l-.027.624",
    transform: "translate(-2495.75 1447.562)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path502",
    d: "M2533.314-1311.739a.2.2,0,0,1,.205-.2.2.2,0,0,1,.2.2.2.2,0,0,1-.2.2.2.2,0,0,1-.205-.2",
    transform: "translate(-2497.816 1338.105)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path504",
    d: "M2526.913-1279.126a.205.205,0,0,1,.205-.2.2.2,0,0,1,.2.2.2.2,0,0,1-.2.2.205.205,0,0,1-.205-.2",
    transform: "translate(-2492.053 1308.741)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path506",
    d: "M2311.959-1167.419H2206.074v-47.218h105.885v47.218",
    transform: "translate(-2203.185 1250.493)",
    fill: "#b8c0c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    d: "M2288.135-1221.83H2177.074v-3.767h111.061v3.767",
    transform: "translate(-2177.074 1260.361)",
    fill: "#d4d5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path510",
    d: "M2311.959-1049.333H2206.074v-18.1h105.885v18.1",
    transform: "translate(-2203.185 1117.963)",
    fill: "#d4d5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    d: "M2495.75-1232.608h-17.3v-.776h17.3v.776",
    transform: "translate(-2448.417 1267.373)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    d: "M2618.255-1411.994H2595.42l2.239-16.335h22.836l-2.239,16.335",
    transform: "translate(-2553.734 1442.894)",
    fill: "#384152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path518",
    d: "M2623.655-1411.994H2600.82l2.239-16.335h22.835l-2.239,16.335",
    transform: "translate(-2558.594 1442.894)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path520",
    d: "M2695.089-1357.45l-1.932,13.139h-4.577l.084-.584,1.847-12.554h4.577",
    transform: "translate(-2637.611 1379.075)",
    fill: "#384152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M2696.5-1344.311h-4.577l1.933-13.139h4.577l-1.933,13.139",
    transform: "translate(-2640.623 1379.075)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path524",
    d: "M2696.127-1230.879h7.585a.585.585,0,0,0-.585-.585h-6.916l-.085.585",
    transform: "translate(-2644.405 1265.643)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M2692.169-1230.879h-3.588l.084-.585h2.919a.585.585,0,0,1,.585.585",
    transform: "translate(-2637.611 1265.643)",
    fill: "#384152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path528",
    d: "M3002.349-1006.39h.041a.434.434,0,0,0,.433-.445l-.656-28.628-1.935-.227,1.649,28.856a.469.469,0,0,0,.467.444",
    transform: "translate(-2918.207 1089.379)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path530",
    d: "M3115.469-1006.39h.042a.434.434,0,0,0,.433-.445l-.656-28.628-1.934-.227,1.648,28.856a.47.47,0,0,0,.468.444",
    transform: "translate(-3020.055 1089.379)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path532",
    d: "M2818.16-1006.39h-.041a.434.434,0,0,1-.433-.445l.658-28.628,1.933-.227-1.65,28.856a.468.468,0,0,1-.468.444",
    transform: "translate(-2753.85 1089.379)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path534",
    d: "M2908.206-1284.943v-19.617a6.232,6.232,0,0,0-6.214-6.25H2887.94a6.232,6.232,0,0,0-6.214,6.25v20.367l26.479-.749",
    transform: "translate(-2811.51 1337.084)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path536",
    d: "M2856.46-1048.127h27.125a1.873,1.873,0,0,0,1.872-1.872v-1.225h-29v3.1",
    transform: "translate(-2788.761 1103.365)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M2811.376-1048.127h20.518a1.384,1.384,0,0,0,1.383-1.385v-.329a1.383,1.383,0,0,0-1.383-1.383h-20.518a1.383,1.383,0,0,0-1.383,1.383v.329a1.384,1.384,0,0,0,1.383,1.385",
    transform: "translate(-2746.923 1103.365)",
    fill: "#677282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path540",
    d: "M2843.7-1369.446s1.262-.427,1.519,2.168c.194,1.97-1.173,17.266-2.2,18.481-2.894,3.42-6.52,1.976-7.941,2.494l-1.339-1.2s4.711-3.477,5.07-4.612c1.38-4.369.438-15.678,4.893-17.328",
    transform: "translate(-2768.305 1389.898)",
    fill: "#43a1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M2943.085-1540.6s-.081-2.8,3.619-3.355,4.721.313,5.351,1.257a16.521,16.521,0,0,1,1.691,6.331c-.119,1.533-4.339,3.428-4.269,4.323s-6.392-8.556-6.392-8.556",
    transform: "translate(-2866.754 1547.152)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path544",
    d: "M2892.244-1239.157s.02,2.823.012,3.976c-.011,1.362-2.7,5-2.7,5l3.663-.631s2.28-2.768,2.276-2.947-3.247-5.4-3.247-5.4",
    transform: "translate(-2818.556 1272.57)",
    fill: "#2b6eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M2691.023-827c.119.947-1.173,1.226-2.677,1.358s-1.038.429-3.089.886-2.9-.088-3.058-.367c-.142-.247.8-.676,1.811-1.159.126-.061.254-.122.38-.185,1.134-.558,1.742-1.633,2.605-2.64.817-.954,1.52-3.939,1.52-3.939l2.785-.714s-.693,2.689-.927,3.834a3.587,3.587,0,0,0,.358,1.973,3.807,3.807,0,0,1,.293.951",
    transform: "translate(-2631.852 907.569)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path548",
    d: "M2688.346-773.169c-1.5.133-1.038.429-3.089.886s-2.9-.088-3.058-.367c-.142-.247.8-.676,1.811-1.159l.016.016a5.785,5.785,0,0,0,3.129-.076c1.354-.428,2.644-1.307,3.575-1.61a3.806,3.806,0,0,1,.293.951c.119.947-1.173,1.226-2.677,1.358",
    transform: "translate(-2631.852 855.095)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M2761.043-1177.481s-18.614,1.93-21.682,4.781-2.522,29.4-2.522,29.4c.479.5.831.484,1.585.425a10.562,10.562,0,0,0,2.2-.68s3.986-13.035,4.035-16.054.681-8.139,1.947-8.441,16.335,1.387,17.988-3.373a10.263,10.263,0,0,0-1.091-8.676l-2.462,2.623",
    transform: "translate(-2681.027 1219.401)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "M2915.295-1355.51a8.488,8.488,0,0,1-4.649,1.452c-4.313.157-9.694-.357-10.753-1.358a1.818,1.818,0,0,1-.447-1.229c-.117-1.654.674-4.377,1.2-6.629a7.2,7.2,0,0,0,.16-3.308c-.585-1.968-2.175-6.043-2.332-7.361s1.357-6.882,3.5-7.823a17.992,17.992,0,0,1,10.591-1.014c3.278.666,3.475,7.24,2.386,13.188-.028.153-.057.306-.086.457-1.18,6.04,2.662,12.123.422,13.624",
    transform: "translate(-2826.582 1402.219)",
    fill: "#43a1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M2958.438-1424.525c.059.384,1.108,1.006,3.351.414,2.148-.566,2.719-1.131,2.719-1.592,0-.547-1.247-1.42-1.235-4.787l-.258.052-4.332.857s.1,1.365.1,2.648c0,1.079-.445,1.77-.347,2.407",
    transform: "translate(-2880.564 1444.838)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    d: "M2961.02-1429.113s.1,1.365.1,2.648c2.425-.068,3.706-2.28,4.23-3.5l-4.333.857",
    transform: "translate(-2882.902 1444.37)",
    fill: "#d69271"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M2935.638-1496.615s5.736.094,5.739-3.479.747-5.967-2.915-6.179-4.375,1.152-4.667,2.344.35,7.2,1.842,7.314",
    transform: "translate(-2858.328 1513.088)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    d: "M2955.032-1513.506s1.571,4.192,3.98,4.811,3.456-.025,3.456-.025a6.826,6.826,0,0,1-2.233-4.033s-4.021-2.749-5.2-.753",
    transform: "translate(-2877.511 1520.235)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M2932.693-1509.706a5.057,5.057,0,0,0-1.458,1.846c-.286.91-.415,2.782-.96,2.72,0,0-1.184-2.85.146-4.462,1.41-1.709,2.273-.1,2.273-.1",
    transform: "translate(-2854.781 1516.776)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    d: "M2841.017-838.682c.044.955-1.266,1.124-2.777,1.129s-1.069.34-3.149.623-2.883-.332-3.019-.623c-.122-.258.855-.606,1.9-1q.2-.074.395-.151c1.174-.461,1.866-1.48,2.807-2.411.892-.882-1.265-4.948-1.265-4.948l2.615-1.4s.6,2.932,1.326,5.49c.189.662.769,1.742.954,2.32a3.753,3.753,0,0,1,.215.973",
    transform: "translate(-2766.794 919.91)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "M2924-1262.2c-.8.538-2.125,2.077-4.533,2.163-3.978-.9-8.506-1.957-11.2-2.587-.117-1.654,2.881-1.253,3.412-3.506a15.859,15.859,0,0,0,7.177-6.723c1.062-1.855,1.6-5.875,1.6-5.875l3.323,3.158c-.028.153-.057.306-.086.457-1.18,6.04,2.548,11.412.307,12.913",
    transform: "translate(-2835.404 1308.2)",
    fill: "#2b6eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    d: "M2838.24-766.99c-1.509.005-1.069.34-3.149.623s-2.883-.332-3.019-.623c-.122-.258.855-.606,1.9-1l.014.019a5.786,5.786,0,0,0,3.125.187c1.383-.313,2.74-1.081,3.692-1.3a3.753,3.753,0,0,1,.215.973c.044.955-1.266,1.124-2.777,1.129",
    transform: "translate(-2766.794 849.346)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M2819.177-1153.417c-5.49-.422-18.77,1.484-21.481,3.529-3.338,2.517,6.2,29.729,6.2,29.729a12.243,12.243,0,0,0,1.458.068,10.458,10.458,0,0,0,2.618-.636s-.522-16.014-1.637-19.078c-1.03-2.83-1.661-3.832-.371-4s17.387,1.884,18.73-2.976a12.038,12.038,0,0,0-.5-7.309s-.663,1.008-5.011.674",
    transform: "translate(-2735.214 1195.98)",
    fill: "#384152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    d: "M2948.635-1378.144a4.8,4.8,0,0,1,2.634,2.972c1.172,3.04,2.145,15.3,1.117,16.516-2.892,3.42-12.541,4.144-13.962,4.664l-.391-1.617s10.3-5.19,10.143-6.369-2.688-16.633.46-16.166",
    transform: "translate(-2862.205 1397.718)",
    fill: "#43a1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "M3015.107-1545.476s-.235-1.5,1.84-1.882,2.115,4.023,2.337,5.086-.332,1.7-1.124,1.764-3.053-4.968-3.053-4.968",
    transform: "translate(-2931.591 1550.082)",
    fill: "#151f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    d: "M2878.9-1158.631s-2.934-.831-3.633-.635-3.093,1.779-2.755,2.209,2.445-.258,3.416-.127,1.721.608,2.42.5a8.012,8.012,0,0,0,1.429-.377l-.876-1.574",
    transform: "translate(-2803.185 1200.666)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "M2917.833-1163.384a11.026,11.026,0,0,1-1.844-1.157.114.114,0,0,0-.178.021c-.109.173-.211.5.292.837a2.7,2.7,0,0,0,1.73.3",
    transform: "translate(-2842.117 1205.42)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    d: "M2783.069-1149.037s-3.044.167-3.642.577-2.349,2.688-1.891,2.985,2.229-1.038,3.19-1.229,1.825.017,2.452-.307a8.179,8.179,0,0,0,1.229-.822l-1.34-1.2",
    transform: "translate(-2717.633 1191.431)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Admin_Host",
    "data-name": "Admin/Host",
    transform: "translate(406.162 257.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_lines-2",
    "data-name": "Mobile lines",
    transform: "translate(31.678 71.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46-3",
    "data-name": "path46",
    d: "M323.455-267.229h.637V-312.5a18.289,18.289,0,0,1,18.27-18.269h46.58a18.928,18.928,0,0,0,18.906-18.906V-434.3a18.289,18.289,0,0,1,18.268-18.268H544.889v-.637H426.116A18.927,18.927,0,0,0,407.21-434.3v84.626a18.29,18.29,0,0,1-18.269,18.269h-46.58A18.927,18.927,0,0,0,323.455-312.5v45.273",
    transform: "translate(-323.455 453.208)",
    fill: "#7f8998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path784-2",
    "data-name": "path784",
    d: "M538.235-440.079a10.617,10.617,0,0,1,10.6,10.605,10.617,10.617,0,0,1-10.6,10.606,10.617,10.617,0,0,1-10.606-10.606A10.617,10.617,0,0,1,538.235-440.079Zm0,21.848a11.255,11.255,0,0,0,11.242-11.243,11.255,11.255,0,0,0-11.242-11.242,11.255,11.255,0,0,0-11.243,11.242,11.255,11.255,0,0,0,11.243,11.243",
    transform: "translate(-437.978 447.463)",
    fill: "#7f8998"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Settings_1",
    "data-name": "Settings 1",
    d: "M659.592-315.431a24.915,24.915,0,0,0-.328-35.233,24.915,24.915,0,0,0-35.234.328,24.914,24.914,0,0,0,.328,35.233A24.915,24.915,0,0,0,659.592-315.431Zm-58.809,7.209a47.582,47.582,0,0,1-5.19-12.222l-9.186-1.76-.095-10.161-.094-10.161,9.152-1.931a47.6,47.6,0,0,1,4.961-12.318l-5.247-7.734,7.119-7.252,7.117-7.252,7.831,5.1a47.576,47.576,0,0,1,12.222-5.19l1.761-9.186,10.161-.1,10.161-.094,1.931,9.152a47.6,47.6,0,0,1,12.317,4.961l7.735-5.247,7.252,7.118,7.251,7.118-5.1,7.831a47.514,47.514,0,0,1,5.19,12.222l9.187,1.761.094,10.161.1,10.161-9.153,1.931a47.58,47.58,0,0,1-4.961,12.318l5.247,7.734-7.117,7.252-7.118,7.253-7.831-5.1a47.6,47.6,0,0,1-12.223,5.19l-1.76,9.186-10.161.094-10.161.1-1.931-9.153a47.509,47.509,0,0,1-12.317-4.961l-7.734,5.248-7.253-7.118-7.252-7.118,5.1-7.831",
    transform: "translate(-586.217 495.092)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Settings_icon-2",
    "data-name": "Settings icon",
    d: "M234.578-441.315a18.6,18.6,0,0,0,2.445-26.2,18.6,18.6,0,0,0-26.2-2.445,18.6,18.6,0,0,0-2.446,26.2A18.606,18.606,0,0,0,234.578-441.315Zm-44.234.866a35.518,35.518,0,0,1-2.922-9.475l-6.69-2.009.705-7.554.705-7.555,6.945-.736a35.544,35.544,0,0,1,4.626-8.771l-3.308-6.145,5.841-4.844,5.84-4.844,5.427,4.388a35.5,35.5,0,0,1,9.475-2.922l2.009-6.69,7.555.7,7.555.705.735,6.946a35.5,35.5,0,0,1,8.771,4.625l6.145-3.307,4.845,5.84,4.843,5.84-4.387,5.427a35.528,35.528,0,0,1,2.922,9.476l6.689,2.009-.7,7.554-.706,7.555-6.945.736a35.535,35.535,0,0,1-4.626,8.77L255-428.578l-5.841,4.844-5.84,4.843-5.427-4.387a35.558,35.558,0,0,1-9.475,2.922l-2.009,6.69-7.554-.705-7.555-.705-.735-6.946a35.491,35.491,0,0,1-8.771-4.626l-6.145,3.308-4.844-5.84-4.844-5.841,4.387-5.427",
    transform: "translate(21.725 569.259)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_sitting",
    "data-name": "Girl sitting",
    transform: "translate(24.781 46.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path244",
    d: "M725.741-349.068s-2.4,4.063-3.408,4.726c-1.373.9-.512,1.811.139,1.811s3.984.239,4.718-.594,1.1-3.329,1.78-3.981,1.388-3.248-.333-3.879c-1.52-.557-2.9,1.917-2.9,1.917",
    transform: "translate(-721.601 437.957)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    d: "M726.308-350.817s-2.744,4.757-3.218,5.461.891.7,1.735.366,2.97-3.745,3.276-4.367a2.292,2.292,0,0,0,.064-1.591l-1.858.13",
    transform: "translate(-721.13 437.92)",
    fill: "#202338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    d: "M722.79-347.032l-.634,4.877-.335.015.1-3.509.865-1.383",
    transform: "translate(-714.832 436.696)",
    fill: "#355c17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "M691.149-349.061s-2.4,4.063-3.407,4.726c-1.374.9-.513,1.811.139,1.811s3.983.239,4.716-.594,1.1-3.329,1.781-3.981,1.411-3.316-.332-3.879c-1.529-.494-2.9,1.917-2.9,1.917",
    transform: "translate(-663.248 437.951)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "M691.585-350.807s-2.6,4.747-3.073,5.451.89.7,1.735.366,2.97-3.745,3.276-4.367a2.292,2.292,0,0,0,.066-1.591l-2,.14",
    transform: "translate(-662.79 437.92)",
    fill: "#202338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M688.212-347.032l-.633,4.877-.335.015.1-3.509.864-1.383",
    transform: "translate(-656.494 436.696)",
    fill: "#355c17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M710.684-403.494,689-393.613a4.169,4.169,0,0,0-2.692,3.474c-.846,8.388-7.121,21.695-7.121,21.695-2.013.985-1.858.13-1.858.13,1.268-4.073,2.813-20.857,3.364-27.605.115-1.429.189-2.409.2-2.721.011-.213.245-.492.646-.817,2.975-2.412,15.218-7.408,15.218-7.408,9.192-.233,13.922,3.372,13.922,3.372",
    transform: "translate(-672.152 455.417)",
    fill: "#202338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M698.989-399.929c-.672,5.861-9.038,5.19-9.038,5.19h-10.14a63.353,63.353,0,0,1,3.691,10.926c1.091,5.3,3.665,14.691,3.665,14.691s-.169.319-2,.14c0,0-7.96-15.863-11.006-19.852a26.926,26.926,0,0,1-2.857-8.3c-.109-.935-.042-1.657.307-1.95a25.349,25.349,0,0,1,2.238-1.53c3.177-2,8.692-5.086,11.765-5.777,4.116-.925,10.626-2.659,10.626-2.659a11.206,11.206,0,0,1,2.751,9.115",
    transform: "translate(-656.37 456.095)",
    fill: "#202338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    d: "M694.822-466.493a9.444,9.444,0,0,0,.778-5.95c-.739-3.068-3.587-6.126-7.756-4.722s-7.539,4.643-5.04,8.387-2.26,5.436-1.048,7.218.753,3.642.24,4.057-2.171,1.892-1.988,3.641,8.088-5.1,8.088-5.1,4.305-8.652,6.726-7.533",
    transform: "translate(-659.104 477.516)",
    fill: "#464240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M675.432-408.524s.628,3.05,16.823-.8c0,0-5.43-1.8-16.823.8",
    transform: "translate(-652.42 456.374)",
    fill: "#eb4747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    d: "M691.6-421.087l.753,1.437-17.76.518c.936-3.136.633-7.382.469-10.605-.2-3.936-2.375-6.674-2.143-10.655-1.171.189-1.373.225-2.546.405,1.793-5.112,2.408-7.643,7.98-9.61a10.4,10.4,0,0,1,4.97-.606c6.454.532,8.4.608,11.569,6.456-4.961.79-4.145,2.572-5.649,7.507-.734,2.407-1.5,5.093-1.106,7.632.387,2.5,3.463,5.241,3.463,7.52",
    transform: "translate(-651.583 468.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M690.471-450.681c2.641-.5,2.079-1.968,2.079-1.968s-.122-.829-.17-1.876c-.013-.268-.02-.552-.019-.838a11.441,11.441,0,0,1,.073-1.3c.216-1.772-4.794-.716-4.794-.716s.288,3.588-.4,4.663.592,2.533,3.233,2.035",
    transform: "translate(-660.751 471.314)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "M691.439-450.586s-5.328,6.151-7.3,7.577c0,0-2.263-2.045-.868-7.444,0,0,2.571-1.288,8.164-.133",
    transform: "translate(-656.68 469.242)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "M690.467-472.364s2.766,5.331.022,10.38-8.135-2.2-8.484-3.049-2.2-5.66,1.48-7.122,6.2-1.656,6.982-.209",
    transform: "translate(-655.853 476.215)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M689.961-470.975s1.9,2.5,2.129,4.35a9.909,9.909,0,0,0-1.385-6.852c-2.144-3.358-7.594-.159-8.325,1.182s-2.87,2.523.725,8.288c0,0,6.465-4.491,6.856-6.968",
    transform: "translate(-656.267 476.717)",
    fill: "#464240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "M687.373-456.032a5.171,5.171,0,0,0,2.357,2.026c-.013-.268-.02-.552-.019-.838a4.486,4.486,0,0,1-2.338-1.187",
    transform: "translate(-658.101 470.795)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M643.163-414.869s1.316.585,1.939.32a5.821,5.821,0,0,1,1.893-.318c.407,0,1.68-.454,1.657.042s-2.067.845-2.486,1,1.252,1.075,1.408,1.483-1.731,3.09-2.794,2.326-1.64-2.29-1.857-2.386a7.77,7.77,0,0,1-.8-.526l1.038-1.942",
    transform: "translate(-585.93 457.977)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    d: "M641.957-411.45a27.564,27.564,0,0,1,3.133,2.9c.048.345-.114.507-.413.279s-3.058-2.383-3.058-2.383,3.09,3.65,3.194,3.921c.06.158-.236.487-.408.381s-3.46-3.543-3.46-3.543,2.879,3.414,2.894,3.669a.335.335,0,0,1-.565.226c-.233-.238-3.1-3.25-3.1-3.25s1.927,2.62,1.808,2.851c-.072.142-.316.437-.79-.256s-1.778-2.2-1.778-2.2l2.542-2.6",
    transform: "translate(-580.515 456.848)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M687.019-394.739H696.1s8.366.671,9.037-5.19a11.2,11.2,0,0,0-2.75-9.115s-4.42,1.177-8.278,2.109a29.856,29.856,0,0,0-6.98-.608s-16.357,5.4-15.865,8.25c0,0,6.842-3.658,15.754,4.554",
    transform: "translate(-662.52 456.095)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    d: "M706.46-403.112l-17.315-.254,8.743,4.438Z",
    transform: "translate(-676.049 454.319)",
    fill: "#5e5853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M684.968-406.961a14.813,14.813,0,0,0,8.669.145l.224-1.783-9.831.547.937,1.091",
    transform: "translate(-659.935 455.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    d: "M689.823-398.812l8.573-3.32V-403l-9.251,3.338.678.847",
    transform: "translate(-667.984 454.203)",
    fill: "#91887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "M711.573-419.142a.856.856,0,0,1-1.19.85l-1.006-.43a.715.715,0,0,1-.425-.772c.419-2.619,1.316-12.813,0-14.563a6.341,6.341,0,0,1-.959-1.709c-.867,2.235-1.944,5.112-2.373,6.661l-8.181,10.883-2.742.7a92.659,92.659,0,0,1,6.172-12.616c.535-1.437,2.071-5.79,3.43-9.665.859-2.447,1.647-4.7,2.072-5.917a2.773,2.773,0,0,1,1.2-1.467c1.267-.758,3.378-1.951,5.293-2.881l.024-.011c.06-.029.121-.06.183-.088h0c-3.641,5.508-2.221,21.063-1.5,31.009,0,.007,0,.016,0,.022",
    transform: "translate(-686.481 468.962)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    d: "M656.662-449.939c1.166.181,4.058,2.987,5.593,5.821,1.754,3.233,3.537,6.915,4.874,8.127,2.458,2.227,9.339,10.1,9.667,9.909a21.485,21.485,0,0,1-2.143,2.465c-.128.056-11.311-9.634-12.385-11.11-1.018-1.4-3.742-7.274-4.556-7.145a.006.006,0,0,1,0,0v0a43.6,43.6,0,0,0-1.992,5.421l-.047.157a17.428,17.428,0,0,0-.237,7.238,24.641,24.641,0,0,0,2.678,6.918,1.087,1.087,0,0,1-.037.838h0a.6.6,0,0,1-.3.347l-3.284,1.217-.771.286a1.674,1.674,0,0,1-1.573-.218,1.665,1.665,0,0,1-.678-1.141c-.73-5.615-1.654-11.353-2.389-13.514a20.468,20.468,0,0,1,1.263-16.609,61.157,61.157,0,0,1,6.319.987",
    transform: "translate(-618.056 469.198)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "M723.375-403.309l-5.15-14.061-16.6.271,4.908,12.958,16.846.832",
    transform: "translate(-701.536 458.7)",
    fill: "#6e6760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "M719.229-408.914c.507,1.013.355,2.116-.342,2.464s-1.669-.191-2.176-1.2-.354-2.116.342-2.464,1.67.192,2.176,1.2",
    transform: "translate(-707.853 456.464)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    d: "M696.611-464.24a2.984,2.984,0,0,0-.081,3.083c.983,1.428-.248,2.831-.461,4.341s4.1,5.527-.7,7.548-6.326-1.319-5.1-3.158a10.375,10.375,0,0,0,2.2-5.952c.1-2.62.967-6.707,4.144-5.862",
    transform: "translate(-667.733 473.398)",
    fill: "#464240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    d: "M667.258-474.184H657.248v8.785l1.528-1.529h8.482v-7.255",
    transform: "translate(-614.928 476.474)",
    fill: "#76b745"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Message_throw",
    "data-name": "Message throw",
    transform: "translate(82.136 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path788",
    d: "M410.078-584.6l.1-.951a55.97,55.97,0,0,0-5.771-.321l0,.956A55.054,55.054,0,0,1,410.078-584.6Zm-16.936.886a52.161,52.161,0,0,1,5.6-.911l-.1-.951a53.18,53.18,0,0,0-5.7.928Zm28.084,1.344.264-.919c-1.884-.543-3.769-1.007-5.6-1.377l-.189.937C417.507-583.362,419.366-582.9,421.226-582.368Zm-38.889,2.154c1.831-.774,3.573-1.429,5.326-2l-.3-.908c-1.778.581-3.545,1.245-5.4,2.03Zm49.6,1.74.381-.877c-1.8-.782-3.6-1.5-5.347-2.142l-.328.9C428.372-579.963,430.153-579.25,431.936-578.475ZM372.1-575.157c1.872-1.026,3.527-1.9,5.058-2.662l-.426-.856c-1.543.771-3.208,1.647-5.091,2.679Zm70.064,1.749.463-.837c-1.713-.946-3.427-1.846-5.1-2.674l-.425.856C438.766-575.241,440.467-574.348,442.168-573.408ZM362.1-569.569c1.62-.881,3.228-1.786,5.012-2.793l-.47-.833c-1.779,1-3.385,1.908-5,2.786Zm-61.063,1.929.044-.955c-1.9-.089-3.836-.109-5.766-.058l.025.956c1.908-.05,3.818-.031,5.7.057Zm150.929.125.52-.8c-1.637-1.062-3.277-2.088-4.873-3.05l-.494.818c1.587.957,3.218,1.978,4.847,3.034Zm-167.968.91c1.884-.31,3.785-.56,5.653-.741l-.092-.951c-1.889.183-3.812.436-5.716.75Zm28.338.352.188-.937c-1.875-.377-3.791-.686-5.694-.92l-.117.948C308.589-566.93,310.481-566.625,312.332-566.253Zm39.375,1.648c1.683-.657,3.409-1.416,5.277-2.321l-.417-.86c-1.845.894-3.548,1.643-5.207,2.29Zm-78.826.56c1.835-.541,3.692-1.029,5.519-1.452l-.215-.931c-1.846.427-3.722.92-5.574,1.466Zm50.459.825.269-.917c-.613-.18-1.239-.377-1.859-.586-1.195-.4-2.413-.777-3.621-1.117l-.259.92c1.193.336,2.4.706,3.576,1.1.632.212,1.269.413,1.894.6Zm17.2,1.543a42.657,42.657,0,0,0,5.683-1.118l-.246-.923a41.855,41.855,0,0,1-5.555,1.092Zm-5.784.3.021-.956a40.405,40.405,0,0,1-5.638-.529l-.155.943A41.422,41.422,0,0,0,334.752-561.379Zm-72.626,1.17c1.766-.739,3.558-1.434,5.326-2.065l-.322-.9c-1.783.637-3.591,1.339-5.372,2.083Zm-10.306,4.93c1.679-.906,3.393-1.778,5.093-2.592l-.413-.863c-1.714.821-3.442,1.7-5.134,2.614Zm-9.8,5.894c1.572-1.049,3.2-2.079,4.829-3.061l-.493-.819c-1.646.99-3.283,2.028-4.867,3.085Zm-9.148,6.849c.016-.014,1.612-1.432,4.471-3.557l-.57-.767c-2.9,2.153-4.52,3.6-4.537,3.61l.636.714",
    transform: "translate(-232.241 585.871)",
    fill: "#c2bebc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path796",
    d: "M215.645-532.958,194.469-544.8l7.279-.48Z",
    transform: "translate(24.998 567.204)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path798",
    d: "M206.453-531.513l-6.516-10.481-5.468-.145Z",
    transform: "translate(34.19 565.76)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path800",
    d: "M194.893-539.349l-.424,2.668,16.73,6.451Z",
    transform: "translate(29.444 564.476)",
    fill: "#c2c2c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8-2",
    "data-name": "g8",
    transform: "translate(247.418 155.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-2",
    "data-name": "path16",
    d: "M127.872-45.929h-5.631v.073h5.631v-.073",
    transform: "translate(-40.113 132.943)",
    fill: "#d9d7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18-2",
    "data-name": "path18",
    d: "M293.76-46.639H282.347v-.073H293.76v.073",
    transform: "translate(-240.925 133.555)",
    fill: "#d9d7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20-2",
    "data-name": "path20",
    d: "M262.728-51.379h-5.1v-.073h5.1v.073",
    transform: "translate(-204.5 137.261)",
    fill: "#d9d7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36-2",
    "data-name": "path36",
    d: "M442.974-216.346a5.979,5.979,0,0,0,5.979,5.979,5.979,5.979,0,0,0,5.979-5.979,5.979,5.979,0,0,0-5.979-5.979,5.979,5.979,0,0,0-5.979,5.979",
    transform: "translate(-437.135 270.861)",
    fill: "#ebe9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46-4",
    "data-name": "path46",
    d: "M172.088-313.136c-.722-2.113-.149-3.617,1.614-3.617a7.09,7.09,0,0,1,3.812,1.556,1.179,1.179,0,0,1,1.259-.879c1.2,0,2.861,1.017,4.161,2.453a1.99,1.99,0,0,1,1.355-.548,6.017,6.017,0,0,1,3.757,1.471.651.651,0,0,1,.533-.274,2.569,2.569,0,0,1,2.007,1.317c.028.048.053.094.077.141H171.737a2.382,2.382,0,0,1,.35-1.621",
    transform: "translate(-113.7 344.691)",
    fill: "#ebe9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52-2",
    "data-name": "path52",
    d: "M140.343-369.332l-66.3,9.544-8.9,8.98,75.2-18.524",
    transform: "translate(-40.129 385.802)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54-3",
    "data-name": "path54",
    d: "M307.463-323.536l10.418-2.566-1.52-6.414,13.445-1.935-13.445,1.935-8.9,8.98",
    transform: "translate(-282.451 358.529)",
    fill: "#d5e3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56-3",
    "data-name": "path56",
    d: "M131.445-369.332l-66.3,9.544L68.218-346.8l63.226-22.529",
    transform: "translate(-31.231 385.802)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58-3",
    "data-name": "path58",
    d: "M68.218-346.8h0l8.539-9.532,12.811-3.045-10.981-2.343-13.445,1.935,1.52,6.414,1.557,6.571m36.415-16.157,26.812-6.372-26.258,3.78-.553,2.592",
    transform: "translate(-31.231 385.802)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60-3",
    "data-name": "path60",
    d: "M178.736-443.4l-3.85,18.04a1.822,1.822,0,0,0,1.4,2.155l34.342,7.329a1.821,1.821,0,0,0,2.155-1.4l3.85-18.04a1.818,1.818,0,0,0-.29-1.421,1.816,1.816,0,0,0-1.108-.735L180.891-444.8a1.817,1.817,0,0,0-1.311.218,1.819,1.819,0,0,0-.844,1.179",
    transform: "translate(-140.387 444.835)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62-3",
    "data-name": "path62",
    d: "M211-415.834a1.823,1.823,0,0,0,1.778-1.437l.273-1.279-5.608,2,3.179.679a1.8,1.8,0,0,0,.377.04m-12.279-2.58,15.065-3.58,2.842-13.317a1.806,1.806,0,0,0,.04-.375,1.826,1.826,0,0,0-.33-1.045,1.816,1.816,0,0,0-1.108-.735L180.892-444.8a1.8,1.8,0,0,0-.378-.04,1.827,1.827,0,0,0-.934.258,1.819,1.819,0,0,0-.844,1.179l-3.85,18.04a1.81,1.81,0,0,0-.04.376,1.823,1.823,0,0,0,1.437,1.779l.657.141,3.776.806.073.015,3.427.731.073.015,14.434,3.08",
    transform: "translate(-140.387 444.835)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-3",
    "data-name": "path64",
    d: "M176.357-444.577l11.475,14.086a7.4,7.4,0,0,0,9.059,1.934l16.226-8.174a1.817,1.817,0,0,0-1.108-.735L177.668-444.8a1.817,1.817,0,0,0-1.311.218",
    transform: "translate(-137.163 444.835)",
    fill: "#aad08e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66-3",
    "data-name": "path66",
    d: "M128.368-369.332l-54.688,13L65.142-346.8l63.226-22.529",
    transform: "translate(-28.154 385.802)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68-3",
    "data-name": "path68",
    d: "M65.142-346.8l3.343-1.191.073-.026,3.427-1.221.073-.026,14.431-5.142,5.429-1.934.07-.025,1.984-.707,1.243-.443,5.608-2,27.547-9.815-54.688,13L65.142-346.8",
    transform: "translate(-28.154 385.802)",
    fill: "#d5e3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70-3",
    "data-name": "path70",
    d: "M156.067-308.08l6.085-3.565L162-311.9l-6.085,3.565.147.251",
    transform: "translate(-81.739 340.894)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72-3",
    "data-name": "path72",
    d: "M196.287-286.8l2.189-1.282-.147-.251-2.189,1.282.147.251",
    transform: "translate(-126.836 322.472)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74-3",
    "data-name": "path74",
    d: "M119.829-369.332l-54.688,13,10.63,12.813Z",
    transform: "translate(-19.615 385.802)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76-3",
    "data-name": "path76",
    d: "M357.549-246.549a.579.579,0,0,0,.214-.041l8.91-3.527a.581.581,0,0,0,.327-.755.581.581,0,0,0-.755-.327l-8.91,3.528a.581.581,0,0,0-.327.755.582.582,0,0,0,.541.368",
    transform: "translate(-330.482 293.47)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78-3",
    "data-name": "path78",
    d: "M357.549-246.549a.579.579,0,0,0,.214-.041l8.91-3.527a.582.582,0,0,0,.368-.542.579.579,0,0,0-.041-.213.581.581,0,0,0-.54-.368.585.585,0,0,0-.215.041l-8.91,3.528a.582.582,0,0,0-.368.542.58.58,0,0,0,.041.213.582.582,0,0,0,.541.368",
    transform: "translate(-330.483 293.47)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80-3",
    "data-name": "path80",
    d: "M374.052-264.117a.585.585,0,0,0,.214-.041l4.785-1.895a.581.581,0,0,0,.327-.755.581.581,0,0,0-.755-.327l-4.785,1.895a.581.581,0,0,0-.327.755.581.581,0,0,0,.541.368",
    transform: "translate(-346.46 305.928)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82-3",
    "data-name": "path82",
    d: "M374.052-264.117a.586.586,0,0,0,.214-.041l4.785-1.895a.581.581,0,0,0,.368-.542.581.581,0,0,0-.041-.213.581.581,0,0,0-.54-.368.584.584,0,0,0-.215.041l-4.785,1.895a.581.581,0,0,0-.368.542.581.581,0,0,0,.041.213.581.581,0,0,0,.541.368",
    transform: "translate(-346.46 305.928)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84-3",
    "data-name": "path84",
    d: "M310.305-246.636a.584.584,0,0,0,.214-.041l8.687-3.439a.582.582,0,0,0,.327-.755.582.582,0,0,0-.755-.327l-8.687,3.439a.581.581,0,0,0-.327.755.582.582,0,0,0,.541.368",
    transform: "translate(-272.711 293.468)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86-2",
    "data-name": "path86",
    d: "M310.306-246.636a.585.585,0,0,0,.214-.041l2.522-1,.073-.029,3.427-1.357.073-.029,2.593-1.026a.582.582,0,0,0,.368-.542.58.58,0,0,0-.041-.213.581.581,0,0,0-.541-.368.587.587,0,0,0-.214.041l-8.687,3.439a.582.582,0,0,0-.368.542.581.581,0,0,0,.041.213.582.582,0,0,0,.541.368",
    transform: "translate(-272.711 293.469)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88-3",
    "data-name": "path88",
    d: "M487.6-350.32c-.77,1.5-1.477,3.01-2.148,4.553s-1.3,3.1-1.844,4.738l-.2.62c-.033.11-.085.291-.112.42s-.056.273-.072.4a10.489,10.489,0,0,0-.1,1.415,24.95,24.95,0,0,0,.121,2.6,41.813,41.813,0,0,0,.792,5.009l1.595-.177c.021-1.638.036-3.293.093-4.906.029-.805.075-1.609.156-2.367a9.513,9.513,0,0,1,.173-1.054c.016-.082.038-.144.057-.212s.033-.089.065-.175l.219-.55c.608-1.472,1.292-2.956,1.989-4.434l2.112-4.431-2.9-1.449",
    transform: "translate(-481.456 370.937)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90-3",
    "data-name": "path90",
    d: "M503.921-262.854l.745,1.393-2.378.663a2.487,2.487,0,0,1,.087-2l1.547-.052",
    transform: "translate(-499.768 302.55)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92-3",
    "data-name": "path92",
    d: "M501.219-254.462l-2.187.172-1.1-1.517,2.378-.663.912,2.008",
    transform: "translate(-495.41 297.558)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94-3",
    "data-name": "path94",
    d: "M448.63-397.647c.034.169.152.288.262.265s.172-.178.138-.347-.152-.288-.262-.265-.172.178-.138.346",
    transform: "translate(-432.474 408.213)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96-3",
    "data-name": "path96",
    d: "M444.828-395.062a6.169,6.169,0,0,0,1.1,1.28.992.992,0,0,1-.776.315l-.324-1.6",
    transform: "translate(-428.536 405.919)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98-2",
    "data-name": "path98",
    d: "M450.315-401.953a.1.1,0,0,0,.074-.033.8.8,0,0,1,.679-.273.1.1,0,0,0,.116-.083.1.1,0,0,0-.083-.116,1,1,0,0,0-.861.335.1.1,0,0,0,.005.143l.069.027",
    transform: "translate(-434.968 411.707)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100-2",
    "data-name": "path100",
    d: "M450.974-385.506c.306,1.563.612,4.427-.481,5.47,0,0,.427,1.586,3.332,1.586,3.194,0,1.526-1.585,1.526-1.585-1.743-.416-1.7-1.71-1.395-2.924l-2.982-2.546",
    transform: "translate(-439.628 398.447)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102-3",
    "data-name": "path102",
    d: "M450.933-364.065c-.231-.766-.485-1.643.041-1.917.578-.3,3.741-.61,4.831-.043s.781,2.121.781,2.121l-5.653-.16",
    transform: "translate(-440.508 383.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104-2",
    "data-name": "path104",
    d: "M505.864-25.616l.062.006a.137.137,0,0,1,.094.068c.046.084.019.119.01.13-.092.12-.528.122-.847.068A1.66,1.66,0,0,1,505.864-25.616Zm-.267.407a.687.687,0,0,0,.513-.141.206.206,0,0,0,0-.24.235.235,0,0,0-.159-.118c-.314-.072-.9.331-.927.348l-.021.051.038.04a2.693,2.693,0,0,0,.558.061",
    transform: "translate(-501.88 117.139)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106-3",
    "data-name": "path106",
    d: "M507.614-27.992h.023c.066.008.072.038.074.051.026.141-.246.495-.466.661a1.219,1.219,0,0,1,.252-.669A.178.178,0,0,1,507.614-27.992Zm-.432.866.024-.006c.221-.12.649-.588.6-.826a.166.166,0,0,0-.161-.133.281.281,0,0,0-.216.065c-.248.2-.3.819-.3.846l.023.046.027.008",
    transform: "translate(-504.011 118.997)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108-3",
    "data-name": "path108",
    d: "M446.713-25.646a.381.381,0,0,1,.1.012.152.152,0,0,1,.1.071c.036.063.023.094.01.112-.1.133-.636.141-1.037.085A2.286,2.286,0,0,1,446.713-25.646Zm-.339.415c.274,0,.538-.038.627-.161a.192.192,0,0,0,0-.221.254.254,0,0,0-.161-.118c-.353-.095-1.1.329-1.134.347l-.025.052.04.042a3.739,3.739,0,0,0,.656.06",
    transform: "translate(-429.827 117.162)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110-3",
    "data-name": "path110",
    d: "M448.786-27.991h.03c.091.009.1.045.1.057.023.145-.324.508-.587.666a1.187,1.187,0,0,1,.282-.659A.269.269,0,0,1,448.786-27.991Zm-.521.866.021,0c.258-.115.769-.577.73-.819-.009-.057-.049-.127-.188-.142a.371.371,0,0,0-.281.087,1.443,1.443,0,0,0-.332.823l.021.046.03.009",
    transform: "translate(-432.364 118.997)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112-3",
    "data-name": "path112",
    d: "M451.664-41.626H453.8l.213-4.948h-2.137l-.213,4.948",
    transform: "translate(-438.112 133.447)",
    fill: "#f3646c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114-3",
    "data-name": "path114",
    d: "M506.527-41.626h2.137l1.074-4.948H507.6l-1.074,4.948",
    transform: "translate(-505.803 133.447)",
    fill: "#f3646c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116-3",
    "data-name": "path116",
    d: "M498.5-25.025h-2.4a.186.186,0,0,0-.182.146l-.422,1.9a.314.314,0,0,0,.313.38c.838-.015,1.245-.063,2.3-.063.649,0,1.988.067,2.884.067.877,0,1.014-.887.647-.967a5.291,5.291,0,0,1-2.793-1.33.517.517,0,0,0-.347-.132",
    transform: "translate(-495.487 116.599)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118-3",
    "data-name": "path118",
    d: "M431.993-25.025H429.66a.187.187,0,0,0-.182.146l-.422,1.9a.311.311,0,0,0,.308.38c.841-.014,2.058-.063,3.116-.063,1.237,0,2.305.067,3.756.067.877,0,1.12-.887.753-.967-1.671-.366-3.036-.4-4.481-1.3a.988.988,0,0,0-.514-.167",
    transform: "translate(-416.319 116.599)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120-3",
    "data-name": "path120",
    d: "M361.477-380.758a49.585,49.585,0,0,0,5.324-.708c.882-.169,1.765-.358,2.648-.6a20.788,20.788,0,0,0,2.665-.879c.224-.092.45-.2.675-.3a6.429,6.429,0,0,0,.726-.423c.42-.278.78-.564,1.137-.849.712-.57,1.374-1.162,2.027-1.76,1.3-1.2,2.535-2.448,3.723-3.758l-1.07-1.2-4.22,3.033c-.7.5-1.4.993-2.091,1.455-.345.229-.7.446-1.017.627a3.458,3.458,0,0,1-.419.205c-.173.067-.348.134-.532.2a31.183,31.183,0,0,1-4.806,1.076c-1.661.263-3.377.479-5.034.651l.265,3.228",
    transform: "translate(-344.771 402.923)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122-3",
    "data-name": "path122",
    d: "M483.5-358.448c-2,.459-4.027,6.314-4.027,6.314l4.122,2.957s1.152-2.727,2.284-5.112c1.187-2.5-.332-4.628-2.379-4.159",
    transform: "translate(-476.464 377.343)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124-3",
    "data-name": "path124",
    d: "M492.377-349.075s.319-.756.786-1.819h0c-.356.809-.626,1.44-.735,1.7h0a22.318,22.318,0,0,1,.535-4.539,44.367,44.367,0,0,0-.681-4.607h0l.193-.037c-.064.01-.128.022-.193.037-2,.459-4.027,6.314-4.027,6.314l.739.53,2.644,1.9.739.53",
    transform: "translate(-485.243 377.241)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126-3",
    "data-name": "path126",
    d: "M484.261-343.548l.817,1.829c-.846,1.827-1.62,3.635-1.827,4.119a16.988,16.988,0,0,1,1.009-5.948",
    transform: "translate(-476.068 365.642)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128-3",
    "data-name": "path128",
    d: "M488.255-332.552c.11-.257.38-.888.735-1.7-.042-.925-.107-1.877-.2-2.843a22.315,22.315,0,0,0-.535,4.539",
    transform: "translate(-481.07 360.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130-3",
    "data-name": "path130",
    d: "M444.581-360.09s2.274,2.569.126,18.467H433.279c-.079-1.754,1.024-10.312-.668-18.578a29.85,29.85,0,0,1,3.826-.483,41.929,41.929,0,0,1,4.858,0,21.444,21.444,0,0,1,3.286.593",
    transform: "translate(-425.572 379.096)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132-3",
    "data-name": "path132",
    d: "M433.279-341.623h11.428a87.8,87.8,0,0,0,.923-11.541c0-.611-.012-1.171-.033-1.683a13.056,13.056,0,0,1-2.146-.875,6.151,6.151,0,0,1-2.913-.968,3.013,3.013,0,0,1-1.1-2.15c0-.9.622-1.677,2.075-1.822l-.218-.022c-.566-.052-1.293-.072-2.054-.072-.966,0-1.987.032-2.8.071a29.842,29.842,0,0,0-3.826.483,44.372,44.372,0,0,1,.681,4.608c.094.966.158,1.918.2,2.843h0c.049,1.059.068,2.083.068,3.054,0,3.738-.285,6.7-.285,7.862,0,.078,0,.148,0,.21m12.307-13.471c-.007-.146-.015-.288-.023-.426h0q.013.207.024.426",
    transform: "translate(-425.573 379.096)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134-3",
    "data-name": "path134",
    d: "M435.769-343.548c.076.6.134,1.315.172,2.155a11.937,11.937,0,0,1-3.182-1.495l3.01-.66",
    transform: "translate(-415.916 365.642)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136-3",
    "data-name": "path136",
    d: "M434.906-336.805q-.016-.351-.036-.673c-.665-.037-1.4-.1-2.111-.2a13.052,13.052,0,0,0,2.146.875h0",
    transform: "translate(-414.881 361.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138-3",
    "data-name": "path138",
    d: "M422.388-357.988c1.529,1.355,7.37,1.219,7.37,1.219l.193-5.646a43.326,43.326,0,0,1-5.954.432c-3.264-.066-3.286,2.508-1.609,4",
    transform: "translate(-407.423 380.393)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140-3",
    "data-name": "path140",
    d: "M429.318-356.765c.277,0,.44,0,.44,0l.193-5.646a45.065,45.065,0,0,1-5.534.436q-.212,0-.42,0l-.122,0c-1.819,0-2.586.848-2.587,1.847a3.013,3.013,0,0,0,1.1,2.15,6.152,6.152,0,0,0,2.913.968c.709.1,1.446.165,2.111.2h0c.792.044,1.482.053,1.905.053",
    transform: "translate(-407.423 380.393)",
    fill: "#474b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142-3",
    "data-name": "path142",
    d: "M352.458-397.235l1.466-1.712,1.566,1.734a2.74,2.74,0,0,1-2.5,1.366l-.533-1.388",
    transform: "translate(-317.948 408.957)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144-3",
    "data-name": "path144",
    d: "M349.626-408.1l.564,2.234-1.069,1.5-1.566-1.734,2.071-2",
    transform: "translate(-311.579 416.114)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146-3",
    "data-name": "path146",
    d: "M453.914-46.568l-.109,2.551h-2.137l.109-2.551h2.138",
    transform: "translate(-438.013 133.443)",
    fill: "#e04c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148-3",
    "data-name": "path148",
    d: "M507.081-46.568h2.138l-.555,2.551h-2.137l.554-2.551",
    transform: "translate(-505.285 133.443)",
    fill: "#e04c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150-3",
    "data-name": "path150",
    d: "M455.849-420.274c1.917-.886,2.523-4.752-2.991-3.794,0,0,.831.921-.857,1.5s-.275,4.2,3.848,2.292",
    transform: "translate(-441.235 428.716)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152-3",
    "data-name": "path152",
    d: "M447.527-405.96c.549,2.048.766,3.275,2.03,4.126a2.817,2.817,0,0,0,4.343-2.36c.066-1.954-.843-4.975-3.04-5.388a2.892,2.892,0,0,0-3.332,3.622",
    transform: "translate(-437.076 417.313)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154-3",
    "data-name": "path154",
    d: "M463.137-419.9c-1.3.73-3.074,1.165-2.9,2.2.218,1.265-1.069.473-.77,2.358.2,1.23,2.465,4.958,4.062,4.776,2.4-.274,2.1-3.941,2.1-5.869,0-1.136.058-4.9-2.5-3.464",
    transform: "translate(-451.439 425.592)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156-3",
    "data-name": "path156",
    d: "M457.193-411.266c.582.137,1.352,3.49-.9,3.8-2.593.353.9-3.8.9-3.8",
    transform: "translate(-442.705 418.588)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158-3",
    "data-name": "path158",
    d: "M448.584-413.286c.713.063,2.321-.8,2.129-2.085a7.537,7.537,0,0,1-2.129,2.085",
    transform: "translate(-434.155 421.798)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160-3",
    "data-name": "path160",
    d: "M454.618-396.58a2.4,2.4,0,0,0,1.054,1.122c.614.32.96-.148.821-.763-.125-.553-.6-1.387-1.228-1.455s-.9.515-.647,1.1",
    transform: "translate(-441.246 407.968)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162-3",
    "data-name": "path162",
    d: "M479.779-411.119a2.859,2.859,0,0,1-1.682-2.13s-.96,2.681,1.682,2.13",
    transform: "translate(-469.607 420.139)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164-3",
    "data-name": "path164",
    d: "M482.676-405.817a1.472,1.472,0,0,1,1.392-.137s-.9-1.162-1.392.137",
    transform: "translate(-474.931 414.809)",
    fill: "#242d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166-3",
    "data-name": "path166",
    d: "M469.725-273.046s-2.425,16.328-3.756,22.446c-1.458,6.7-8.411,31.66-8.411,31.66h-2.133s3.3-24.421,4.134-31.053c.9-7.2,2.791-23.053,2.791-23.053h7.374",
    transform: "translate(-454.644 310.519)",
    fill: "#445263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168-3",
    "data-name": "path168",
    d: "M455.426-219.848h3.543c1.235-5.033,6.136-25.079,7.371-30.752q.027-.122.053-.25c-.108-1.717-.211-3.95-.211-6.213a29.491,29.491,0,0,1,.861-8.281c-.218-4.336-.406-7.7-.406-7.7h-3.916s-1.889,15.854-2.791,23.053c-.71,5.658-3.714,25.366-4.5,30.145",
    transform: "translate(-455.014 310.519)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174-3",
    "data-name": "path174",
    d: "M461.938-246.453c-2.8.55-2.507,11.005-2.17,16.383.808-3.8,1.992-11.116,2.8-16.308a.962.962,0,0,0-.631-.076",
    transform: "translate(-448.39 289.743)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176-3",
    "data-name": "path176",
    d: "M467.727-223.238c.313-1.472.683-3.472,1.065-5.671-.125-2.925-.276-6.072-.415-8.828a29.5,29.5,0,0,0-.861,8.281c0,2.263.1,4.5.211,6.213a.02.02,0,0,1,0,0",
    transform: "translate(-456.349 282.911)",
    fill: "#4e782f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178-3",
    "data-name": "path178",
    d: "M443.66-273.046s.294,15.975.062,22.491c-.242,6.777-3.493,31.606-3.493,31.606h-2.144s-.724-24.432-.885-31.089c-.175-7.256-1.051-23.008-1.051-23.008h7.512",
    transform: "translate(-424.525 310.519)",
    fill: "#445263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180-3",
    "data-name": "path180",
    d: "M437.482-219.927h3.434c.254-2.425,1.139-10.7,1.648-16.062.542-5.707,1.053-11.607,1.158-14.567.066-1.842.089-4.44.089-7.22,0-7.052-.151-15.271-.151-15.271h-7.512s.187,3.366.406,7.7c.139,2.755.291,5.9.415,8.828h0c.1,2.409.186,4.667.229,6.432,0,.016,0,.031,0,.046.112,4.626.21,16.565.26,23.417,0,.024,0,.048,0,.073.008,1.177.015,2.2.021,3.008,0,.024,0,.048,0,.073,0,.211,0,1.99,0,2.169m5.335-36.46c0,2.777-.024,5.374-.089,7.205-.19,5.331-1.695,20.192-2.333,26.334l-.036.032h0l-.032-.04h0c.638-6.141,2.142-21,2.332-26.329.065-1.83.089-4.426.089-7.2,0-5.478-.09-11.66-.129-14.056h0l.036-.037h0l.036.036c.039,2.4.13,8.58.13,14.058",
    transform: "translate(-424.525 310.519)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182-3",
    "data-name": "path182",
    d: "M440.744-219.912l.036-.033c.638-6.142,2.142-21,2.333-26.334.194-5.442.018-17.651-.041-21.264l-.036-.036h0l-.036.037c.059,3.612.235,15.82.041,21.26-.19,5.329-1.694,20.188-2.332,26.329l.032.04h0",
    transform: "translate(-424.91 306.243)",
    fill: "#3a66b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184-3",
    "data-name": "path184",
    d: "M440.744-219.912l.036-.033c.638-6.142,2.142-21,2.333-26.334.065-1.831.089-4.428.089-7.205,0-5.479-.09-11.661-.13-14.058l-.036-.036h0l-.036.037c.039,2.4.129,8.579.129,14.056,0,2.777-.024,5.373-.089,7.2-.19,5.329-1.694,20.188-2.332,26.329l.032.04h0",
    transform: "translate(-424.91 306.243)",
    fill: "#4e782f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Parson-2",
    "data-name": "Parson",
    transform: "translate(89.364 86.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54-4",
    "data-name": "path54",
    d: "M310.838-377.473c-.1-7.041-9.478-20.138-9.478-20.138a3.727,3.727,0,0,0-.44-.166c-.006.006-.483-.067-.483-.061s-1.457-1.38-1.466-1.38c-.344,1.252-3.45,18.94-4.211,29.237C303.565-371.71,310.889-374.115,310.838-377.473Zm-78.574-31.8q-.836-11.287-1.166-21.126c1.816-.962,4-2.086,5.745-2.915,5.406-2.574,12.938-6.04,17.771-8.257,2.829-1.3,5.6-2.25,5.6-2.25s19.315-1.851,20.883-1.752a48.527,48.527,0,0,1,6.076,2.078c6.849,2.6,20.055,7.891,22.157,9.4,3.084,2.207,14.117,56.291,14.41,59.964.286,3.568-15.006,8.45-29.167,12.189.01,5.483.121,13.164.246,20.176.019,1.2.041,2.374.064,3.514H232.919c.083-1.2.156-2.393.216-3.514.006-.15.016-.3.022-.443.236-4.749,1.159-13.256.924-21.54,0,0,.15-8.733-.717-12.491-.1-16.6-1.1-33.034-1.1-33.034",
    transform: "translate(-177.63 503.419)",
    fill: "#92be70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56-4",
    "data-name": "path56",
    d: "M354.99-339.264c.408-2.934.793-5.866,1.141-8.736,0-.016.006-.025.006-.042.112-.956.227-1.9.335-2.838.007-.045.009-.1.016-.15.453-3.953.828-7.745,1.1-11.217a35.5,35.5,0,0,0-.346-7.8c-1.077-17.756-1.613-36.475-1.613-36.475-.567-7.662-.892-14.824-1.108-21.5,0,0,24.254-11.463,26.453-12.119,0,0-4.6,10.8-8.051,34.949-1.325,9.274-3.782,24.885-5.565,40.818v0c-.965,8.6-2.775,17.356-4.151,25.108-.21,1.2-.411,2.371-.6,3.514H354.49q.259-1.753.5-3.514",
    transform: "translate(-301.502 500.92)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58-4",
    "data-name": "path58",
    d: "M270.776-383.013c.213-8.079.176-13.717.176-13.717-.8,2.768-1.906,10.678-2.88,18.541C271.349-379.839,270.734-381.382,270.776-383.013ZM241.6-369.428c-.956-8.978-1.816-17.936-1.4-22.845,3.345-39.467,12.81-49.913,14.184-51.443,1.061.4,5.1,1.921,6.283,2.389,6.474,2.552,19.669,7.229,21.447,8.507,3.084,2.208,15.241,58.907,15.608,62.574.246,2.479-15.621,7.658-31.808,12.281.15,4.438-.27,10.7,1.2,17.235a15.129,15.129,0,0,1,.7,3.425l-22.565-.089q-.205-1.749-.424-3.514c-.429-3.527-.879-7.139-1.324-10.978-6.767,1.751-11.368,2.88-11.368,2.88s-6.356-10.746-8.2-15.1c-.315-.742,7.866-2.708,17.666-5.325",
    transform: "translate(-147.727 502.564)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60-4",
    "data-name": "path60",
    d: "M329.912-460.173s-2.456-4.642-1.777-17.822c.187-3.651-19.179,8.659-19.179,8.659s.067,1.258.109,2.956c.022.707.035,1.481.035,2.278,0,.22,0,.439,0,.66,0,.36-.006.717-.013,1.074-.009.443-.026.876-.048,1.293-.022.475-.054.923-.1,1.335a12.148,12.148,0,0,1-.717,2.588c-.889,2.048,14.442,2.166,21.693-3.02",
    transform: "translate(-225.43 518.639)",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62-4",
    "data-name": "path62",
    d: "M337.672-428.9l-3.569,4.8s2.091,2.8,5.805.732l-2.236-5.528",
    transform: "translate(-249.428 495.751)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66-4",
    "data-name": "path66",
    d: "M323.249-438.344l3.821,4.471s6.134-1.188,7.934-4.392-11.755-.079-11.755-.079",
    transform: "translate(-238.825 500.721)",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-4",
    "data-name": "path64",
    d: "M348.3-419.773s-13.077,31.938-10.287,72.507l4.124,7.485,4.651-6.375s.75-53.879,4.462-73.746l-2.95.128",
    transform: "translate(-262.667 491.612)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68-4",
    "data-name": "path68",
    d: "M340.7-444.426s.444,3.408,4.7,8.384l-4.644,6.239-2.513-12.943,2.459-1.68",
    transform: "translate(-257.155 502.89)",
    fill: "#759c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70-4",
    "data-name": "path70",
    d: "M321.768-452.015s-8.868,10.031-15.07,12.483l2.884,7.133,14.154-15.613-1.968-4",
    transform: "translate(-218.453 506.38)",
    fill: "#759c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72-4",
    "data-name": "path72",
    d: "M385.148-346.795s11.772-11.417,19.492-13.315c3.569-.879,8.27-5.806,12.737-11.6,1.472-1.907,2.917-3.909,4.291-5.89a.012.012,0,0,0,0-.008c5.481-7.914,9.775-15.5,9.775-15.5s16.2-18.985,3.2-27.448c0,0-5.571-.12-8.628,1.54-3.142,1.706-9.845,15.694-10.981,18.172s-13.447,25.482-14.271,26a34.156,34.156,0,0,1-7.124,5.061c-6.031,3.247-15.5,12.75-15.5,12.75l7.009,10.236",
    transform: "translate(-373.003 491.912)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74-4",
    "data-name": "path74",
    d: "M352.694-276.447a7.476,7.476,0,0,0,2.349-.447s1.23-.789,2.138-1.3a6.868,6.868,0,0,1,.718-.363,13.7,13.7,0,0,0,3.954-1.884c1.548-1.18,6.594-5.9,6.594-5.9l-3.262-5.014-1.506-4.965s-11.765,1.17-13.334,2.1a4.662,4.662,0,0,0-.432.289,17.446,17.446,0,0,0-2.4,2.685c-.22.206-2.269,2.4-2.154,3.289a2.932,2.932,0,0,0,1.534,2.4,7.008,7.008,0,0,0,1.658,3.479,4.354,4.354,0,0,0,2.238,3.127s.57,2.227,1.906,2.495",
    transform: "translate(-284.043 434.777)",
    fill: "#efaa88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76-4",
    "data-name": "path76",
    d: "M322.792-540.707s-21.265-5.126-16.786,21.8,9.58,29.109,22.534,23.741,12.054-22.589,12.825-31.016-11.771-14.129-18.574-14.523",
    transform: "translate(-235.407 547.347)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78-4",
    "data-name": "path78",
    d: "M309.472-507.579c.315-2.365,5.011-3.164,5.336.392s-2.271,9.755-4.039,9.115-1.733-6.247-1.3-9.508",
    transform: "translate(-210.915 532.865)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80-4",
    "data-name": "path80",
    d: "M338.157-517.742s-.426-8.468-3.511-8.778-3.612,3.091-3.612,3.091l-3.129.544s1.1-7.4-1.971-8.742-20.051,3.789-22.5,1.576-1.059-17.237,3.451-19.23,16.948-6.424,25.921-.156c0,0,7.077-.7,8.041,5.015s-.71,22.468-2.693,26.68",
    transform: "translate(-233.442 552.669)",
    fill: "#16202e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82-4",
    "data-name": "path82",
    d: "M292.241-302.443l8.78,15.1s23.26-5.994,28.688-7.525L317.3-309.638s-18.292,4.179-25.061,7.2",
    transform: "translate(-216.617 440.904)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84-4",
    "data-name": "path84",
    d: "M317.526-454.558h0a20.337,20.337,0,0,0,15.827-9.943,23.577,23.577,0,0,1-15.766,6.916c0,.22,0,.439,0,.66,0,.36-.006.716-.013,1.074-.009.443-.026.876-.047,1.293",
    transform: "translate(-233.921 512.122)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88-4",
    "data-name": "path88",
    d: "M429.682-329.948C416.462-316.34,399-299.2,399-299.2l-6.828-12.961s15.514-18.187,26.031-30.322c3.223,1.581,9.142,5.351,11.483,12.538",
    transform: "translate(-392.168 457.533)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90-4",
    "data-name": "path90",
    d: "M384.331-285.4a38.779,38.779,0,0,0-4.488,2.485c-.93.767-4.695,3.586-5.608,4.249s1.377,2.549,8.109-.367,1.987-6.368,1.987-6.368",
    transform: "translate(-317.047 429.755)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line-3",
    "data-name": "Line",
    transform: "translate(81.031 249.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-4",
    "data-name": "path106",
    d: "M111.224-250.951v0",
    transform: "translate(110.673 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108-4",
    "data-name": "path108",
    d: "M111.224-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(107.259 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110-4",
    "data-name": "path110",
    d: "M117.544-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(97.526 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112-4",
    "data-name": "path112",
    d: "M123.864-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(87.79 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114-4",
    "data-name": "path114",
    d: "M130.185-250.951v3.514H133.6v-3.514h-3.414",
    transform: "translate(78.057 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116-4",
    "data-name": "path116",
    d: "M136.5-250.951v3.514h3.414v-3.514H136.5",
    transform: "translate(68.323 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118-4",
    "data-name": "path118",
    d: "M142.825-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(58.589 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120-4",
    "data-name": "path120",
    d: "M149.145-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(48.856 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122-4",
    "data-name": "path122",
    d: "M155.466-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(39.12 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124-4",
    "data-name": "path124",
    d: "M161.786-250.951v3.514H165.2v-3.514h-3.414",
    transform: "translate(29.386 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126-4",
    "data-name": "path126",
    d: "M168.108-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(19.651 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128-4",
    "data-name": "path128",
    d: "M174.428-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(9.917 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130-4",
    "data-name": "path130",
    d: "M180.749-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(0.182 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132-4",
    "data-name": "path132",
    d: "M187.069-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-9.552 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134-4",
    "data-name": "path134",
    d: "M193.389-250.951v3.514H196.8v-3.514h-3.414",
    transform: "translate(-19.286 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136-4",
    "data-name": "path136",
    d: "M199.709-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-29.018 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138-4",
    "data-name": "path138",
    d: "M206.029-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-38.753 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140-4",
    "data-name": "path140",
    d: "M212.35-250.951v3.514h3.414v-3.514H212.35",
    transform: "translate(-48.487 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142-4",
    "data-name": "path142",
    d: "M218.67-250.951v3.514h3.414v-3.514H218.67",
    transform: "translate(-58.221 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144-4",
    "data-name": "path144",
    d: "M224.99-250.951v3.514H228.4v-3.514H224.99",
    transform: "translate(-67.954 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146-4",
    "data-name": "path146",
    d: "M231.31-250.951v3.514h3.415v-3.514H231.31",
    transform: "translate(-77.69 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148-4",
    "data-name": "path148",
    d: "M237.633-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-87.425 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150-4",
    "data-name": "path150",
    d: "M243.953-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-97.159 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152-4",
    "data-name": "path152",
    d: "M250.273-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-106.893 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154-4",
    "data-name": "path154",
    d: "M256.593-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-116.628 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156-4",
    "data-name": "path156",
    d: "M262.914-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-126.362 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158-4",
    "data-name": "path158",
    d: "M269.234-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-136.096 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160-4",
    "data-name": "path160",
    d: "M275.554-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-145.829 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162-4",
    "data-name": "path162",
    d: "M281.874-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-155.563 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164-4",
    "data-name": "path164",
    d: "M288.194-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-165.297 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166-4",
    "data-name": "path166",
    d: "M294.515-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-175.032 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168-4",
    "data-name": "path168",
    d: "M300.835-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-184.766 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170-2",
    "data-name": "path170",
    d: "M307.157-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-194.501 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172-2",
    "data-name": "path172",
    d: "M313.477-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-204.235 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174-4",
    "data-name": "path174",
    d: "M319.8-250.951v3.514h3.414v-3.514H319.8",
    transform: "translate(-213.971 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176-4",
    "data-name": "path176",
    d: "M326.118-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-223.704 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178-4",
    "data-name": "path178",
    d: "M332.438-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-233.438 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180-4",
    "data-name": "path180",
    d: "M338.758-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-243.172 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182-4",
    "data-name": "path182",
    d: "M345.079-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-252.907 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184-4",
    "data-name": "path184",
    d: "M351.4-250.951v3.514h3.414v-3.514H351.4",
    transform: "translate(-262.639 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186-2",
    "data-name": "path186",
    d: "M357.719-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-272.373 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188-2",
    "data-name": "path188",
    d: "M364.039-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-282.108 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190-2",
    "data-name": "path190",
    d: "M370.36-250.951v3.514h3.414v-3.514H370.36",
    transform: "translate(-291.844 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192-2",
    "data-name": "path192",
    d: "M376.682-250.951v3.514H380.1v-3.514h-3.414",
    transform: "translate(-301.578 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194-2",
    "data-name": "path194",
    d: "M383-250.951v3.514h3.414v-3.514H383",
    transform: "translate(-311.311 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196-2",
    "data-name": "path196",
    d: "M389.322-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-321.045 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198-2",
    "data-name": "path198",
    d: "M395.642-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-330.78 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200-2",
    "data-name": "path200",
    d: "M401.963-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-340.514 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202-2",
    "data-name": "path202",
    d: "M408.283-250.951v3.514H411.7v-3.514h-3.414",
    transform: "translate(-350.248 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204-2",
    "data-name": "path204",
    d: "M414.6-250.951v3.514h3.414v-3.514H414.6",
    transform: "translate(-359.981 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206-2",
    "data-name": "path206",
    d: "M420.923-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-369.715 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208-2",
    "data-name": "path208",
    d: "M427.244-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-379.451 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210-2",
    "data-name": "path210",
    d: "M433.564-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-389.184 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212-2",
    "data-name": "path212",
    d: "M439.886-250.951v3.514H443.3v-3.514h-3.414",
    transform: "translate(-398.92 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214-2",
    "data-name": "path214",
    d: "M446.206-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-408.654 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216-2",
    "data-name": "path216",
    d: "M452.527-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-418.389 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218-2",
    "data-name": "path218",
    d: "M458.847-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-428.123 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220-2",
    "data-name": "path220",
    d: "M465.167-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-437.856 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222-2",
    "data-name": "path222",
    d: "M471.487-250.951v3.514H474.9v-3.514h-3.414",
    transform: "translate(-447.59 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224-2",
    "data-name": "path224",
    d: "M477.807-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-457.324 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226-2",
    "data-name": "path226",
    d: "M484.128-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-467.059 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228-2",
    "data-name": "path228",
    d: "M490.448-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-476.791 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230-2",
    "data-name": "path230",
    d: "M496.768-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-486.525 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232-2",
    "data-name": "path232",
    d: "M503.088-250.951v3.514H506.5v-3.514h-3.415",
    transform: "translate(-496.26 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234-2",
    "data-name": "path234",
    d: "M509.411-250.951v3.514h3.413v-3.514h-3.413",
    transform: "translate(-505.996 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236-2",
    "data-name": "path236",
    d: "M515.731-250.951v3.514h3.414v-3.514h-3.414",
    transform: "translate(-515.73 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238-2",
    "data-name": "path238",
    d: "M522.051-247.438v0",
    transform: "translate(-522.05 250.951)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102-4",
    "data-name": "path102",
    d: "M333.12-250.951v3.514h-221.9v-3.514Z",
    transform: "translate(-111.224 250.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Laptop-2",
    "data-name": "Laptop",
    transform: "translate(69.96 188.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92-4",
    "data-name": "path92",
    d: "M447.79-357.508l6.2,57.673H372.345l-6.2-57.673H447.79",
    transform: "translate(-361.412 360.807)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96-4",
    "data-name": "path96",
    d: "M367.749-260.337H354.112v5.189h13.637v-5.189",
    transform: "translate(-268.671 316.12)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94-4",
    "data-name": "path94",
    d: "M461.436-305.944H380.429l-6.135-57.036H455.3Zm-81.579.638h82.288l-6.271-58.31H373.586l6.272,58.31",
    transform: "translate(-373.586 363.616)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242-2",
    "data-name": "path242",
    d: "M448.01-310.059c.656,3.21-.842,6.229-3.346,6.74s-5.066-1.677-5.722-4.888.841-6.229,3.345-6.741,5.066,1.677,5.722,4.888",
    transform: "translate(-394.821 341.268)",
    fill: "#d4ebc3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "arrow_6_",
    "data-name": "arrow (6)",
    d: "M16.085,244.166V0H6.894V244.166H0l11.489,13.787,11.489-13.787Z",
    transform: "translate(749 386.379) rotate(-90)",
    fillRule: "evenodd",
    opacity: 0.2,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_6_2",
    "data-name": "arrow (6)",
    d: "M16.085,244.166V0H6.894V244.166H0l11.489,13.787,11.489-13.787Z",
    transform: "translate(1323 366.379) rotate(-90)",
    fillRule: "evenodd",
    opacity: 0.2,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_6_3",
    "data-name": "arrow (6)",
    d: "M16.085,244.166V0H6.894V244.166H0l11.489,13.787,11.489-13.787Z",
    transform: "translate(1175.543 453.523)",
    fillRule: "evenodd",
    opacity: 0.2,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_6_4",
    "data-name": "arrow (6)",
    d: "M16.085,13.787V257.953H6.894V13.787H0L11.489,0,22.979,13.787Z",
    transform: "translate(1323 411.32) rotate(-90)",
    fillRule: "evenodd",
    opacity: 0.2,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_6_5",
    "data-name": "arrow (6)",
    d: "M16.085,13.787V257.953H6.894V13.787H0L11.489,0,22.979,13.787Z",
    transform: "translate(1130.602 453.523)",
    fillRule: "evenodd",
    opacity: 0.2,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_36",
    "data-name": "Union 36",
    d: "M-18563-16235.846v-9.2h369.2a9.2,9.2,0,0,1-9.2,9.2Zm360.006-9.2v-244.167h-6.9l11.494-13.785,11.488,13.785h-6.895v244.167Z",
    transform: "translate(19930.77 17058.969)",
    opacity: 0.2,
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25494",
    "data-name": "Group 25494",
    transform: "translate(0 -47.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud",
    transform: "translate(1027.086 305.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21549",
    "data-name": "Path 21549",
    d: "M278.421,267.793c0,29.4-24.351,53.328-54.29,53.328H60.07a54.2,54.2,0,0,1-38.345-15.627,52.285,52.285,0,0,1-15.945-37.7A53.24,53.24,0,0,1,41.092,217.87a93.965,93.965,0,0,1,181.287-3.281c1.081-.07,1.7-.07,1.751-.07.811,0,1.622,0,2.422.054h0a54.258,54.258,0,0,1,35.907,15.508,52.523,52.523,0,0,1,15.962,37.712Z",
    transform: "translate(-3.641 -146.969)",
    fill: "#f1f8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21550",
    "data-name": "Path 21550",
    d: "M69.876,275.9c-.114.4-.222.8-.319,1.211-.616.227-1.222.459-1.827.714Q68.768,276.83,69.876,275.9Z",
    transform: "translate(-32.106 -206.21)",
    fill: "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21551",
    "data-name": "Path 21551",
    d: "M343.39,290.115a46.582,46.582,0,0,1,11.681-10.221,49.523,49.523,0,0,1,14.556-6.021,52.167,52.167,0,0,1,31.35,2.519,54.01,54.01,0,0,1,24.507,19.681,49.1,49.1,0,0,1,6.627,14.286,43.869,43.869,0,0,1,1.454,15.448,52.614,52.614,0,0,0-10.81-27.778,55.944,55.944,0,0,0-23.394-17.67,53.739,53.739,0,0,0-29.064-3.184A55.3,55.3,0,0,0,343.39,290.115Z",
    transform: "translate(-158.764 -204.668)",
    fill: "#c0e5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21552",
    "data-name": "Path 21552",
    d: "M64.26,237.161c.616-.276,1.238-.541,1.87-.8C65.5,236.615,64.876,236.88,64.26,237.161ZM71.146,225.6q.616-1.622,1.308-3.243Q71.763,223.956,71.146,225.6Zm28.913-39.945q-1.227.995-2.422,2.027C98.427,187,99.254,186.319,100.059,185.66Z",
    transform: "translate(-30.511 -164.747)",
    fill: "#55717c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21553",
    "data-name": "Path 21553",
    d: "M146.37,170.273q1.778-1.14,3.611-2.162Q148.154,169.143,146.37,170.273Zm8.313-4.7h0c-.33.162-.665.324-.989.5C154.008,165.905,154.348,165.738,154.683,165.57Z",
    transform: "translate(-68.239 -155.516)",
    fill: "#56aaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21554",
    "data-name": "Path 21554",
    d: "M261.67,310.428a54.62,54.62,0,0,1-37.539,14.837H60.07a54.5,54.5,0,0,1-28.383-7.859q-.676-.411-1.33-.832c-.438-.281-.876-.573-1.308-.87s-.832-.584-1.238-.881l-.043-.032c-.427-.308-.843-.627-1.259-.951s-.784-.622-1.173-.94l-.178-.146c-.276-.232-.541-.459-.816-.7l-.476-.411c-.222-.195-.432-.384-.649-.589-.5-.454-1-.93-1.492-1.411a52.285,52.285,0,0,1-15.945-37.7c0-.416,0-.832,0-1.243v-.843c0-.7.065-1.378.124-2.07A9.41,9.41,0,0,1,6,266.754c.038-.341.054-.54.092-.849s.076-.659.124-.989q.195-1.481.481-2.941c.043-.238.092-.465.141-.7.092-.438.189-.87.281-1.3.076-.3.146-.595.222-.886s.162-.632.249-.946c.059-.227.119-.443.184-.659s.119-.411.184-.622.141-.465.216-.7.135-.427.211-.638q.492-1.5,1.081-2.957c.119-.3.243-.605.368-.9s.249-.6.384-.9.259-.595.4-.886.27-.589.416-.876.281-.584.432-.87.292-.578.449-.859.3-.573.465-.854c.314-.541.638-1.13.973-1.686s.649-1.043.978-1.557a53.914,53.914,0,0,1,3.524-4.778c.178-.222.357-.432.541-.649q1.022-1.157,2.1-2.286c.178-.189.351-.368.541-.541Q22,233.933,23.017,233l.513-.465q1.227-1.081,2.524-2.124L26.6,230c.454-.346.919-.692,1.384-1.027q.324-.235.649-.454c.481-.341.973-.67,1.465-.995.249-.168.508-.324.768-.486l.676-.416.541-.313c.276-.168.541-.33.838-.486l.1-.054c.265-.157.541-.3.811-.449s.589-.319.886-.47l.9-.459.908-.438.924-.427c.616-.276,1.238-.541,1.87-.8s1.216-.486,1.827-.714c.1-.405.211-.805.319-1.211.162-.595.324-1.195.5-1.778s.346-1.184.541-1.773.368-1.173.541-1.757.389-1.157.595-1.724a.076.076,0,0,0,0-.032c.2-.541.395-1.081.605-1.622a.154.154,0,0,1,.043-.124q.627-1.622,1.308-3.243l.114-.265c.2-.465.4-.93.611-1.389l.146-.324c.195-.427.389-.854.589-1.281l.195-.405c.222-.459.438-.913.665-1.368l.114-.232c.254-.508.513-1.016.773-1.519s.541-1.011.8-1.513l.222-.4c.195-.346.378-.692.584-1.032.135-.249.27-.5.422-.741s.362-.632.541-.946l.243-.405c.254-.438.541-.87.795-1.3s.541-.865.822-1.3c.216-.33.427-.665.649-.989l.362-.541c.195-.286.389-.573.589-.854s.384-.541.584-.832.265-.378.405-.573c.222-.314.449-.638.686-.946l.286-.389c.265-.362.541-.724.811-1.081q.795-1.032,1.622-2.054c.243-.3.492-.605.741-.908q.832-1,1.7-1.989c.238-.276.481-.54.73-.822l.222-.243c.346-.384.7-.768,1.049-1.146l.119-.124c.389-.416.784-.827,1.189-1.238,1.854-1.9,3.784-3.735,5.816-5.481q1.195-1.032,2.422-2.027c.508-.411,1.022-.811,1.535-1.211a1.84,1.84,0,0,1,.195-.151c.541-.416,1.081-.822,1.622-1.222s1.119-.811,1.686-1.211h.032c.578-.405,1.162-.8,1.74-1.195s1.178-.773,1.768-1.151q1.778-1.13,3.611-2.162c.611-.346,1.222-.692,1.838-1.027s1.232-.665,1.859-.984c.324-.173.659-.335.989-.5A94.725,94.725,0,0,1,102.653,156c-1.665,1.195-44.7,21.2-42.961,63.009A63.836,63.836,0,0,0,23.325,252.6a52.582,52.582,0,0,0,15.248,46.237,54.193,54.193,0,0,0,38.345,15.627H240.973A54.8,54.8,0,0,0,261.67,310.428Z",
    transform: "translate(-3.641 -151.119)",
    fill: "#c0e5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21555",
    "data-name": "Path 21555",
    d: "M69.744,274.031a54.908,54.908,0,0,0-14.054-1.108,52.972,52.972,0,0,0-26.2,8.535,52.042,52.042,0,0,0-18.21,20.324,52.769,52.769,0,0,0-2.665,6.324c-.368,1.081-.719,2.162-1.011,3.276-.157.541-.286,1.081-.427,1.659s-.162,1.135-.259,1.7q-.465,3.395-.7,6.773c-.151,2.259-.205,4.519-.195,6.794s.119,4.562.249,6.881l.519,7.1c-.33-.513-.654-1.032-.951-1.562s-.573-1.081-.827-1.622-.5-1.141-.741-1.681-.411-1.141-.616-1.719a34.393,34.393,0,0,1-1.584-7.151,36.933,36.933,0,0,1-.108-7.346,36.55,36.55,0,0,1,1.324-7.238l.541-1.757c.162-.589.314-1.178.5-1.757.341-1.168.741-2.319,1.157-3.465a53.58,53.58,0,0,1,3.011-6.643,53.026,53.026,0,0,1,8.535-11.74,54.349,54.349,0,0,1,11.286-9.021,53.414,53.414,0,0,1,13.221-5.643A52.177,52.177,0,0,1,69.744,274.031Z",
    transform: "translate(-1.823 -204.438)",
    fill: "#c0e5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21556",
    "data-name": "Path 21556",
    d: "M377.594,262.6c-23.664,2.605-34.2,17.529-34.2,17.529,8.254-12.346,23.513-24.513,29.923-29.329A111.026,111.026,0,0,1,377.594,262.6Z",
    transform: "translate(-158.764 -194.677)",
    fill: "#c2c9bd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ZKBio-cloud-visitor-gray",
    transform: "translate(1055.332 205.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(31.23 204.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M714.87,239.04a11.187,11.187,0,0,1-5.232,1.1,8.541,8.541,0,0,1-6.495-2.565,9.339,9.339,0,0,1-2.443-6.719,9.746,9.746,0,0,1,2.748-7.207,9.389,9.389,0,0,1,6.943-2.749,11.406,11.406,0,0,1,4.479.774v3.054a7.946,7.946,0,0,0-4.153-1.12,6.579,6.579,0,0,0-4.907,1.934,7.135,7.135,0,0,0-1.873,5.171,6.824,6.824,0,0,0,1.751,4.907,6.073,6.073,0,0,0,4.6,1.832,8.185,8.185,0,0,0,4.561-1.242v2.83Z",
    transform: "translate(-700.7 -220.126)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M789.033,236.867H786V217.2h3.034Z",
    transform: "translate(-768.633 -217.18)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M822.739,261.006a6.554,6.554,0,0,1-4.907-1.853A6.749,6.749,0,0,1,816,254.205a6.547,6.547,0,0,1,7.065-7.105,6.353,6.353,0,0,1,4.846,1.832,7.058,7.058,0,0,1,1.731,5.07,6.969,6.969,0,0,1-1.873,5.09A6.767,6.767,0,0,1,822.739,261.006Zm.143-11.523a3.411,3.411,0,0,0-2.789,1.242,5.1,5.1,0,0,0-1.018,3.4,4.926,4.926,0,0,0,1.038,3.3,3.489,3.489,0,0,0,2.769,1.2,3.281,3.281,0,0,0,2.728-1.181,6.411,6.411,0,0,0,0-6.739A3.253,3.253,0,0,0,822.882,249.482Z",
    transform: "translate(-792.525 -240.992)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M908.729,261.874h-3.013v-2.1h-.041A4.35,4.35,0,0,1,901.6,262.2c-3.135,0-4.7-1.893-4.7-5.66V248.6h3.013v7.614c0,2.382.916,3.583,2.769,3.583a2.788,2.788,0,0,0,2.2-.977,3.809,3.809,0,0,0,.855-2.586V248.6h2.993Z",
    transform: "translate(-856.955 -242.187)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M982.949,236.788h-3.013v-2.26h-.061a5.2,5.2,0,0,1-8.408.774A7.422,7.422,0,0,1,970,230.435a8.079,8.079,0,0,1,1.629-5.273,5.316,5.316,0,0,1,4.337-2,4.148,4.148,0,0,1,3.909,2.158h.061V217.1h3.013Zm-2.972-6.067V228.99a3.4,3.4,0,0,0-.916-2.4,3.088,3.088,0,0,0-2.341-.977,3.153,3.153,0,0,0-2.647,1.262,5.53,5.53,0,0,0-.957,3.481,4.94,4.94,0,0,0,.937,3.2,3.034,3.034,0,0,0,2.5,1.181,3.114,3.114,0,0,0,2.5-1.14A4.61,4.61,0,0,0,979.976,230.721Z",
    transform: "translate(-915.172 -217.1)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1069.189,219.7l5.477,12.826,5.477-12.826h3.889l-9.365,20.258L1065.3,219.7Z",
    transform: "translate(-996.566 -219.171)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1162.992,221.441a1.786,1.786,0,0,1-1.262-.489,1.617,1.617,0,0,1-.529-1.222,1.694,1.694,0,0,1,.529-1.242,1.785,1.785,0,0,1,1.262-.489,1.885,1.885,0,0,1,1.3.489,1.629,1.629,0,0,1,.53,1.242,1.6,1.6,0,0,1-.53,1.2A1.9,1.9,0,0,1,1162.992,221.441Zm1.486,16.064h-3.013V224.21h3.013Z",
    transform: "translate(-1072.942 -217.817)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1192.6,260.193V257.4a6,6,0,0,0,3.726,1.283c1.812,0,2.728-.529,2.728-1.608a1.336,1.336,0,0,0-.224-.774,2.464,2.464,0,0,0-.631-.57,5.765,5.765,0,0,0-.937-.448c-.366-.122-.753-.285-1.2-.448a12.412,12.412,0,0,1-1.466-.692,5.138,5.138,0,0,1-1.1-.814,3.084,3.084,0,0,1-.652-1.038,3.907,3.907,0,0,1-.224-1.364,3.131,3.131,0,0,1,.448-1.69A4.172,4.172,0,0,1,1194.29,248a6.029,6.029,0,0,1,1.731-.753,8.278,8.278,0,0,1,2.016-.244,9.338,9.338,0,0,1,3.3.55v2.626a5.644,5.644,0,0,0-3.217-.957,4.036,4.036,0,0,0-1.038.122,2.821,2.821,0,0,0-.794.326,1.522,1.522,0,0,0-.509.509,1.211,1.211,0,0,0-.183.651,1.4,1.4,0,0,0,.183.733,1.873,1.873,0,0,0,.529.529,5.592,5.592,0,0,0,.855.407c.326.122.713.265,1.14.407a15.8,15.8,0,0,1,1.547.713,5.6,5.6,0,0,1,1.161.814,3.1,3.1,0,0,1,.733,1.059,3.785,3.785,0,0,1,.265,1.425,3.382,3.382,0,0,1-.468,1.771,3.813,3.813,0,0,1-1.242,1.242,5.916,5.916,0,0,1-1.792.733,9.17,9.17,0,0,1-2.138.244A8.645,8.645,0,0,1,1192.6,260.193Z",
    transform: "translate(-1097.949 -240.912)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1253.392,221.441a1.785,1.785,0,0,1-1.262-.489,1.617,1.617,0,0,1-.53-1.222,1.693,1.693,0,0,1,.53-1.242,1.785,1.785,0,0,1,1.262-.489,1.885,1.885,0,0,1,1.3.489,1.629,1.629,0,0,1,.529,1.242,1.6,1.6,0,0,1-.529,1.2A1.9,1.9,0,0,1,1253.392,221.441Zm1.486,16.064h-3.013V224.21h3.013Z",
    transform: "translate(-1144.937 -217.817)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1288.608,246.361a5.349,5.349,0,0,1-2.321.448c-2.586,0-3.868-1.242-3.868-3.705v-7.513H1280.2v-2.362h2.219v-3.074l3.013-.855v3.929h3.176v2.362h-3.176v6.637a2.632,2.632,0,0,0,.428,1.69,1.736,1.736,0,0,0,1.425.509,2,2,0,0,0,1.323-.448Z",
    transform: "translate(-1167.714 -226.816)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1336.039,261.006a6.554,6.554,0,0,1-4.906-1.853,6.749,6.749,0,0,1-1.832-4.947,6.547,6.547,0,0,1,7.065-7.105,6.353,6.353,0,0,1,4.846,1.832,7.058,7.058,0,0,1,1.73,5.07,6.969,6.969,0,0,1-1.873,5.09A6.768,6.768,0,0,1,1336.039,261.006Zm.143-11.523a3.41,3.41,0,0,0-2.789,1.242,5.1,5.1,0,0,0-1.018,3.4,4.924,4.924,0,0,0,1.038,3.3,3.488,3.488,0,0,0,2.769,1.2,3.282,3.282,0,0,0,2.728-1.181,6.411,6.411,0,0,0,0-6.739A3.254,3.254,0,0,0,1336.182,249.482Z",
    transform: "translate(-1206.817 -240.992)",
    fill: "#474a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1419.116,250.495a2.519,2.519,0,0,0-1.568-.428,2.733,2.733,0,0,0-2.239,1.2,5.443,5.443,0,0,0-.9,3.278V260.9H1411.4V247.6h3.013v2.769h.061a4.456,4.456,0,0,1,1.364-2.178,3.022,3.022,0,0,1,2.036-.794,2.526,2.526,0,0,1,1.242.244Z",
    transform: "translate(-1272.202 -241.231)",
    fill: "#474a4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(57.507 169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(59.869 2.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M441.3,209.854V190.2h5.77a6.452,6.452,0,0,1,4.144,1.243,3.977,3.977,0,0,1,1.546,3.284,4.646,4.646,0,0,1-.924,2.869,4.9,4.9,0,0,1-2.534,1.769v.048a4.99,4.99,0,0,1,3.2,1.514,4.613,4.613,0,0,1,1.2,3.268,5.189,5.189,0,0,1-1.817,4.112,6.866,6.866,0,0,1-4.67,1.562H441.3Zm2.534-17.438v6.153h2.311a4.337,4.337,0,0,0,2.885-.893,3.07,3.07,0,0,0,1.052-2.487c0-1.849-1.243-2.773-3.714-2.773Zm0,8.368v6.854h3.044a4.576,4.576,0,0,0,3.076-.924,3.175,3.175,0,0,0,1.084-2.55c0-2.247-1.53-3.379-4.575-3.379Z",
    transform: "translate(-441.3 -189.307)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M534.8,186.162a1.525,1.525,0,0,1,1.562-1.562,1.538,1.538,0,0,1,1.132.446,1.515,1.515,0,0,1,.462,1.116,1.455,1.455,0,0,1-.462,1.1,1.59,1.59,0,0,1-1.132.43,1.552,1.552,0,0,1-1.116-.43A1.442,1.442,0,0,1,534.8,186.162Zm.287,18.984V191.1h2.487v14.043Z",
    transform: "translate(-519.896 -184.6)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M569.3,230.992a7.58,7.58,0,0,1,1.945-5.483,6.966,6.966,0,0,1,5.26-2.008,6.425,6.425,0,0,1,4.957,1.929,8.676,8.676,0,0,1-.112,10.727,6.734,6.734,0,0,1-5.133,2.04,6.556,6.556,0,0,1-5.021-1.977A7.25,7.25,0,0,1,569.3,230.992Zm2.534-.08a5.654,5.654,0,0,0,1.227,3.825,4.182,4.182,0,0,0,3.3,1.4,3.978,3.978,0,0,0,3.252-1.371,7.476,7.476,0,0,0,0-7.858,3.978,3.978,0,0,0-3.252-1.371,4.063,4.063,0,0,0-3.3,1.435A5.879,5.879,0,0,0,571.834,230.912Z",
    transform: "translate(-548.897 -217.299)",
    fill: "#76b745"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_673_",
    transform: "translate(26.061 3.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M256.776,210.387h3.969l-8.257-9.994.08-.08-.064-.048,7.667-9.165h-3.634l-6.185,7.826-.94.94V191.1h-3v16.737h-2.407v-.016H233.44l10.727-15.509V191.1H230.045v2.566h9.9L229.2,209.1v1.291h20.211v-6.918l1.084-1.084Z",
    transform: "translate(-229.2 -191.1)",
    fill: "#474a4e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_542_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M77.017,196.942l-.558-.239c-2.789-1.164-9.42-4.495-10.711-10.409h0a8.359,8.359,0,0,1-.048-.845v-6.535c0-3.523.016-7.077.016-7.125V170.9l11.3-1.9,11.158,1.945v15.111a5.236,5.236,0,0,1-1.148,3.4c-1.658,2.423-4.878,4.862-9.6,7.268Zm-9.149-11.014c.51,2.232,2.072,4.3,4.654,6.169a23.17,23.17,0,0,0,4.431,2.487c8.942-4.638,9.149-7.954,9.149-8.273l-.032-.128.032-.064V172.746l-9.038-1.578-9.181,1.546C67.852,177.942,67.836,185.067,67.868,185.928Zm18.235.414Zm-18.267-.51v.032C67.852,185.864,67.836,185.848,67.836,185.832Z",
    transform: "translate(-65.7 -169)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_665_",
    transform: "translate(8.464 5.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M121.494,206.919a2.71,2.71,0,1,0-2.694-2.71A2.7,2.7,0,0,0,121.494,206.919Zm-.1,11.445,2.742-10.536h-5.212Z",
    transform: "translate(-118.8 -201.5)",
    fill: "#76b745",
    fillRule: "evenodd"
  }))))))), /*#__PURE__*/React.createElement("text", {
    id: "Invite_Visitor",
    "data-name": "Invite Visitor",
    transform: "translate(878 348)",
    fill: "#304669",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -49.658,
    y: 0
  }, "Invite Visitor")), /*#__PURE__*/React.createElement("text", {
    id: "Get_an_invite_over_mail_or_SMS",
    "data-name": "Get an invite over mail or SMS",
    transform: "translate(1452 302)",
    fill: "#304669",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -68.968,
    y: 0
  }, "Get an invite over"), /*#__PURE__*/React.createElement("tspan", {
    x: -48.322,
    y: 26
  }, "mail or SMS")), /*#__PURE__*/React.createElement("text", {
    id: "The_visitor_needs_to_confirm_the_visit_can_update_the_basic_information_at_the_same_time",
    "data-name": "The visitor needs to confirm the visit & can update the basic information at the same time",
    transform: "translate(1452 438)",
    fill: "#304669",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -111.335,
    y: 0
  }, "The visitor needs to confirm"), /*#__PURE__*/React.createElement("tspan", {
    x: -100.635,
    y: 26
  }, "the visit &amp; can update the"), /*#__PURE__*/React.createElement("tspan", {
    x: -70.167,
    y: 52
  }, "basic information"), /*#__PURE__*/React.createElement("tspan", {
    x: -67.157,
    y: 78
  }, "at the same time")), /*#__PURE__*/React.createElement("text", {
    id: "Invitation_came_for_admin_approval_",
    "data-name": "Invitation came for admin approval ",
    transform: "translate(1046 594)",
    fill: "#304669",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -75.037,
    y: 0
  }, "Invitation came for"), /*#__PURE__*/React.createElement("tspan", {
    x: -63.857,
    y: 26
  }, "admin approval ")), /*#__PURE__*/React.createElement("text", {
    id: "On_admin_approval_QR_code_link_will_be_sent_to_visitor_on_Email_or_SMS",
    "data-name": "On admin approval, QR code link will be sent to visitor on Email or SMS",
    transform: "translate(1555 739)",
    fill: "#304669",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -156.362,
    y: 0
  }, "On admin approval, QR code link will be"), /*#__PURE__*/React.createElement("tspan", {
    x: -122.146,
    y: 26
  }, "sent to visitor on Email or SMS")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationImage);
export default __webpack_public_path__ + "static/media/InvitationImage.8213af84adf187b44a91bdb372ddc296.svg";
export { ForwardRef as ReactComponent };